import React, { useEffect, useState, useCallback, useRef } from "react";
import api from "../api/axios";
import homeapi from "../api/homeapi";
import { useAuth } from "../context/AuthContext";

/* ═══════════════════════════════════════════
   CONSTANTS
═══════════════════════════════════════════ */
const PAGES = {
  DASHBOARD:  "dashboard",
  TRIPS:      "trips",
  BOOKINGS:   "bookings",
  REVENUE:    "revenue",
  CARPOOLING: "carpooling",
  RENTAL:     "rental",
};

const TRIP_TYPES = [
  { id: "Taxi-brousse", label: "Taxi-brousse", seats: 22 },
  { id: "Covoiturage",  label: "Covoiturage",  seats: 4  },
];

const FUEL_TYPES   = ["Essence", "Diesel", "Hybride", "Électrique", "GPL"];
const OPERATEURS   = ["MVola", "Orange Money", "Airtel Money", "Autre"];
const CAR_FEATURES = ["Climatisation", "GPS", "Bluetooth", "4x4", "Automatique", "Manuel", "Siège bébé", "Toit ouvrant", "USB / Chargeur", "Caméra de recul"];

const getPhotoUrl = (url) => {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  const BASE = `${homeapi.defaults.baseURL}`;
  return `${BASE}${url.startsWith("/") ? "" : "/"}${url}`;
};

/* ═══════════════════════════════════════════
   ICONS
═══════════════════════════════════════════ */
const BusIcon      = () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><rect x="1" y="4" width="14" height="9" rx="2" stroke="currentColor" strokeWidth="1.5"/><circle cx="4.5" cy="13.5" r="1.5" fill="currentColor"/><circle cx="11.5" cy="13.5" r="1.5" fill="currentColor"/><path d="M1 8h14M5 4V2M11 4V2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const UsersIcon    = () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><circle cx="6" cy="5" r="2.5" stroke="currentColor" strokeWidth="1.5"/><path d="M1 13c0-2.5 2.2-4.5 5-4.5s5 2 5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><circle cx="12" cy="5" r="2" stroke="currentColor" strokeWidth="1.3"/><path d="M14 13c0-2-1.3-3.6-3-4.2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/></svg>;
const MoneyIcon    = () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M8 1v14M5 4h4.5a2 2 0 010 4H5m0 0h5a2 2 0 010 4H5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const CarIcon      = () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><rect x="1" y="6" width="14" height="7" rx="2" stroke="currentColor" strokeWidth="1.5"/><circle cx="4.5" cy="13.5" r="1.5" fill="currentColor"/><circle cx="11.5" cy="13.5" r="1.5" fill="currentColor"/><path d="M1 9l2-5h10l2 5" stroke="currentColor" strokeWidth="1.5"/></svg>;
const HomeIcon     = () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M2 6.5L8 2l6 4.5V14a1 1 0 01-1 1H3a1 1 0 01-1-1V6.5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M6 15V9h4v6" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></svg>;
const KeyIcon      = () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><circle cx="6" cy="7" r="4" stroke="currentColor" strokeWidth="1.5"/><path d="M9 10l5 5M11 12l2-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><circle cx="6" cy="7" r="1.5" fill="currentColor"/></svg>;
const PlusIcon     = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M8 2v12M2 8h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const LogoutIcon   = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M6 2H3a1 1 0 00-1 1v10a1 1 0 001 1h3M10 11l3-3-3-3M13 8H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const ArrowIcon    = () => <svg width="11" height="11" viewBox="0 0 12 12" fill="none"><path d="M2 6h8M7 3l3 3-3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const ClockIcon    = () => <svg width="12" height="12" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5"/><path d="M8 4v4l3 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const ChevronIcon  = () => <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M5 3l3 3-3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const TrashIcon    = () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M2 4h12M5 4V3a1 1 0 011-1h4a1 1 0 011 1v1M6 7v5M10 7v5M3 4l1 9a1 1 0 001 1h6a1 1 0 001-1l1-9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const CheckIcon    = () => <svg width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M3 8l4 4 6-7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const Spinner      = () => <span style={{ display:"inline-block", width:14, height:14, border:"2px solid rgba(255,255,255,0.3)", borderTopColor:"white", borderRadius:"50%", animation:"spin 0.6s linear infinite", marginRight:8, verticalAlign:"middle" }} />;
const WalletIcon   = () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><rect x="1" y="4" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="M1 7h14" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="10" r="1" fill="currentColor"/><path d="M4 2l2-1h4l2 1" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/></svg>;
const TicketIcon   = () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M1 6a1 1 0 011-1h12a1 1 0 011 1v1a2 2 0 000 4v1a1 1 0 01-1 1H2a1 1 0 01-1-1v-1a2 2 0 000-4V6z" stroke="currentColor" strokeWidth="1.5"/><path d="M6 8h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="1.5 2"/></svg>;
const InfoIcon     = () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5"/><path d="M8 7v5M8 5v.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const LocationIcon = () => <svg width="12" height="12" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="6" r="2.5" stroke="currentColor" strokeWidth="1.3"/><path d="M8 2a4 4 0 014 4c0 3-4 8-4 8S4 9 4 6a4 4 0 014-4z" stroke="currentColor" strokeWidth="1.3"/></svg>;
const ShieldIcon   = () => <svg width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M8 2L3 4.5V8c0 3 2.1 5.2 5 6 2.9-.8 5-3 5-6V4.5L8 2z" stroke="currentColor" strokeWidth="1.3"/><path d="M5.5 8l2 2 3-3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/></svg>;
const CameraIcon   = () => <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1 5a2 2 0 012-2h1l1-2h4l1 2h1a2 2 0 012 2v7a2 2 0 01-2 2H3a2 2 0 01-2-2V5z" stroke="currentColor" strokeWidth="1.4"/><circle cx="8" cy="8.5" r="2.2" stroke="currentColor" strokeWidth="1.3"/></svg>;
const FuelIcon     = () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M3 2h7l3 3v9H3V2z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/><path d="M6 6h3M6 9h3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/></svg>;
const XIcon        = () => <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const StarIcon     = () => <svg width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M8 1l2.1 4.3L15 6.1l-3.5 3.4.8 4.8L8 12l-4.3 2.3.8-4.8L1 6.1l4.9-.8L8 1z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/></svg>;
const CloseIcon    = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>;
const ChevLeftIcon = () => <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const ChevRightIcon= () => <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 3l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const AlertIcon    = () => <svg width="18" height="18" viewBox="0 0 16 16" fill="none"><path d="M8 2L1.5 13h13L8 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M8 6v4M8 11.5v.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>;

/* ═══════════════════════════════════════════
   SHARED ATOMS
═══════════════════════════════════════════ */
const Badge = ({ variant = "neutral", children }) => {
  const v = {
    success: { bg:"rgba(74,222,128,0.12)",  color:"#4ade80"  },
    warning: { bg:"rgba(251,191,36,0.12)",  color:"#fbbf24"  },
    danger:  { bg:"rgba(248,113,113,0.12)", color:"#f87171"  },
    info:    { bg:"rgba(96,165,250,0.12)",  color:"#60a5fa"  },
    neutral: { bg:"rgba(139,143,168,0.12)", color:"#8b8fa8"  },
    purple:  { bg:"rgba(167,139,250,0.12)", color:"#a78bfa"  },
  };
  return (
    <span style={{ fontSize:11, padding:"3px 9px", borderRadius:20, fontWeight:600, fontFamily:"'DM Mono',monospace", ...v[variant] }}>
      {children}
    </span>
  );
};

const Avatar = ({ name, color = "#4ade80" }) => {
  const initials = (name||"?").split(" ").map(w=>w[0]).slice(0,2).join("").toUpperCase();
  return (
    <div style={{ width:36, height:36, borderRadius:"50%", background:`${color}18`, color, display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, fontWeight:700, flexShrink:0 }}>
      {initials}
    </div>
  );
};

const Toast = ({ toast }) => {
  if (!toast) return null;
  return (
    <div style={{ position:"fixed", bottom:80, right:16, left:16, maxWidth:380, margin:"0 auto", background:"#16181f", border:`0.5px solid ${toast.type==="success"?"rgba(74,222,128,0.3)":"rgba(248,113,113,0.3)"}`, padding:"11px 18px", borderRadius:10, fontSize:13, color:"#e8e9ed", zIndex:9999, display:"flex", alignItems:"center", gap:8, boxShadow:"0 8px 24px rgba(0,0,0,0.4)" }}>
      <span style={{ width:7, height:7, borderRadius:"50%", background:toast.type==="success"?"#4ade80":"#f87171", flexShrink:0 }} />
      {toast.msg}
    </div>
  );
};

const Field = ({ label, children }) => (
  <div style={{ marginBottom:14 }}>
    <label style={{ display:"block", fontSize:11, fontWeight:600, color:"#8b8fa8", textTransform:"uppercase", letterSpacing:0.5, marginBottom:5 }}>{label}</label>
    {children}
  </div>
);

const inp = {
  width:"100%", padding:"10px 12px", background:"#1e2029", border:"0.5px solid #2a2d38",
  borderRadius:9, fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", color:"#e8e9ed",
  outline:"none", boxSizing:"border-box",
};
const sel = { ...inp, cursor:"pointer" };

const CommissionBanner = ({ type = "trip" }) => {
  const configs = {
    trip:      { emoji: "🚐", label: "trajet (Taxi-brousse / Covoiturage)" },
    rental:    { emoji: "🚗", label: "location de véhicule" },
    carpooling:{ emoji: "🤝", label: "covoiturage" },
  };
  const cfg = configs[type] ?? configs.trip;
  return (
    <div style={{
      background: "linear-gradient(135deg, rgba(251,191,36,0.1), rgba(248,113,113,0.07))",
      border: "1.5px solid rgba(251,191,36,0.35)",
      borderRadius: 11,
      padding: "14px 16px",
      marginBottom: 16,
      display: "flex",
      alignItems: "flex-start",
      gap: 12,
    }}>
      <span style={{ fontSize: 22, flexShrink: 0 }}>{cfg.emoji}</span>
      <div>
        <div style={{ fontSize: 13, fontWeight: 800, color: "#fbbf24", marginBottom: 5, letterSpacing: -0.2 }}>
          💰 Répartition des revenus — {cfg.label}
        </div>
        <div style={{ fontSize: 13, lineHeight: 1.65 }}>
          <span style={{ color: "#4ade80", fontWeight: 800, fontSize: 15 }}>93 %</span>
          <span style={{ color: "#c8cad8", fontWeight: 600 }}> → Vous (transporteur)</span>
          <span style={{ color: "#4a4d5a", fontSize: 12 }}> · votre part sur chaque paiement</span>
        </div>
        <div style={{ fontSize: 13, lineHeight: 1.65 }}>
          <span style={{ color: "#f87171", fontWeight: 800, fontSize: 15 }}>7 %</span>
          <span style={{ color: "#c8cad8", fontWeight: 600 }}> → Plateforme TransTiGo</span>
          <span style={{ color: "#4a4d5a", fontSize: 12 }}> · commission de service</span>
        </div>
        <div style={{ marginTop: 8, fontSize: 11.5, color: "#8b8fa8", background: "rgba(0,0,0,0.2)", borderRadius: 7, padding: "6px 10px" }}>
          <strong style={{ color: "#fbbf24" }}>Exemple :</strong> Pour un billet à <strong style={{ color: "#e8e9ed" }}>10 000 MGA</strong> → vous percevez <strong style={{ color: "#4ade80" }}>9 300 MGA</strong>, la plateforme retient <strong style={{ color: "#f87171" }}>700 MGA</strong>.
        </div>
      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════
   CONFIRM DELETE MODAL
═══════════════════════════════════════════ */
const ConfirmDeleteModal = ({ title, message, onConfirm, onCancel, loading }) => (
  <div
    style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.75)", zIndex:600, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}
    onClick={e => e.target === e.currentTarget && onCancel()}
  >
    <div style={{ background:"#16181f", border:"0.5px solid rgba(248,113,113,0.3)", borderRadius:14, padding:"28px 24px", maxWidth:380, width:"100%", textAlign:"center" }}>
      <div style={{ width:48, height:48, borderRadius:"50%", background:"rgba(248,113,113,0.1)", color:"#f87171", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 16px" }}>
        <AlertIcon />
      </div>
      <div style={{ fontSize:15, fontWeight:700, color:"#e8e9ed", marginBottom:8 }}>{title}</div>
      <div style={{ fontSize:13, color:"#8b8fa8", lineHeight:1.6, marginBottom:24 }}>{message}</div>
      <div style={{ display:"flex", gap:10 }}>
        <button onClick={onCancel} style={{ ...s.ghostBtn, flex:1, justifyContent:"center" }} disabled={loading}>
          Annuler
        </button>
        <button
          onClick={onConfirm}
          disabled={loading}
          style={{ flex:1, display:"inline-flex", alignItems:"center", justifyContent:"center", gap:7, padding:"10px 18px", background:"#f87171", color:"#fff", border:"none", borderRadius:9, fontSize:13, fontWeight:700, cursor: loading ? "not-allowed" : "pointer", fontFamily:"inherit", opacity: loading ? 0.7 : 1 }}
        >
          {loading ? <><Spinner/>Suppression…</> : <><TrashIcon/> Supprimer</>}
        </button>
      </div>
    </div>
  </div>
);

/* ═══════════════════════════════════════════
   MODAL WRAPPER
═══════════════════════════════════════════ */
const Modal = ({ title, subtitle, onClose, children, footer, wide }) => (
  <div
    className="modal-overlay"
    style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.72)", zIndex:500, display:"flex", alignItems:"flex-end", justifyContent:"center", padding:0 }}
    onClick={e => e.target === e.currentTarget && onClose()}
  >
    <div className={`modal-sheet${wide ? " modal-wide" : ""}`}>
      <div className="modal-drag-handle" />
      <div style={{ padding:"18px 20px 14px", borderBottom:"0.5px solid #2a2d38", display:"flex", alignItems:"flex-start", justifyContent:"space-between", gap:12 }}>
        <div>
          <div style={{ fontSize:15, fontWeight:700, color:"#e8e9ed", letterSpacing:-0.3 }}>{title}</div>
          {subtitle && <div style={{ fontSize:12, color:"#8b8fa8", marginTop:3 }}>{subtitle}</div>}
        </div>
        <button onClick={onClose} style={{ background:"rgba(255,255,255,0.06)", border:"none", color:"#8b8fa8", cursor:"pointer", width:30, height:30, borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
          <CloseIcon />
        </button>
      </div>
      <div className="modal-body">{children}</div>
      {footer && (
        <div style={{ padding:"12px 20px 20px", borderTop:"0.5px solid #2a2d38" }}>{footer}</div>
      )}
    </div>
  </div>
);

/* ═══════════════════════════════════════════
   VISUAL SEAT PICKER (SVG)
═══════════════════════════════════════════ */
const VisualSeatPicker = ({ totalSeats, takenSeats = [], selected, onSelect }) => {
  const cols   = totalSeats > 6 ? 3 : 2;
  const svgW   = cols === 3 ? 240 : 180;
  const svgH   = Math.ceil(totalSeats / cols) * 56 + 90;
  const sW = 42; const sH = 38;

  const getCx = (col) => {
    if (cols === 3) return col === 0 ? 18 : col === 1 ? 100 : 180;
    return col === 0 ? 30 : 110;
  };

  return (
    <div style={{ background:"#1a1c25", borderRadius:12, padding:16, border:"0.5px solid #2a2d38", overflowX:"auto" }}>
      <svg viewBox={`0 0 ${svgW} ${svgH}`} style={{ width:"100%", maxWidth:svgW, display:"block", margin:"0 auto" }}>
        <rect x="6" y="6" width={svgW-12} height={svgH-12} rx="18" fill="#16181f" stroke="#2a2d38" strokeWidth="1.5"/>
        <rect x="20" y="14" width={svgW-40} height="28" rx="8" fill="#1e3a5f" stroke="#1d4ed8" strokeWidth="0.8" opacity="0.7"/>
        <text x={svgW/2} y="32" textAnchor="middle" fontSize="9.5" fill="#60a5fa" fontFamily="'Plus Jakarta Sans',sans-serif" fontWeight="600">🚗 Chauffeur</text>
        {Array.from({length:totalSeats},(_,i)=>i+1).map(n => {
          const i = n-1;
          const row = Math.floor(i/cols);
          const col = i % cols;
          const cx  = getCx(col);
          const cy  = 56 + row * 56;
          const isTaken = takenSeats.includes(n);
          const isSel   = selected === n;
          return (
            <g key={n} style={{ cursor:isTaken?"not-allowed":"pointer" }} onClick={() => !isTaken && onSelect(n)}>
              <rect x={cx+4} y={cy-8} width={sW-8} height={12} rx="5" fill={isTaken?"#7f1d1d":isSel?"#15803d":"#2a4a2a"} opacity="0.9"/>
              <rect x={cx} y={cy} width={sW} height={sH} rx="8" fill={isTaken?"#450a0a":isSel?"#166534":"#1e2029"} stroke={isTaken?"#dc2626":isSel?"#4ade80":"#3a3d4a"} strokeWidth="1.5"/>
              {isTaken && <>
                <line x1={cx+9} y1={cy+8} x2={cx+sW-9} y2={cy+sH-8} stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round"/>
                <line x1={cx+sW-9} y1={cy+8} x2={cx+9} y2={cy+sH-8} stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round"/>
              </>}
              {!isTaken && !isSel && (
                <text x={cx+sW/2} y={cy+sH/2+4} textAnchor="middle" fontSize="11" fill="#8b8fa8" fontFamily="'DM Mono',monospace" fontWeight="600">{n}</text>
              )}
              {isSel && (
                <text x={cx+sW/2} y={cy+sH/2+5} textAnchor="middle" fontSize="16" fill="#4ade80">✓</text>
              )}
            </g>
          );
        })}
      </svg>
      <div style={{ display:"flex", gap:16, justifyContent:"center", marginTop:10, flexWrap:"wrap" }}>
        {[["#1e2029/#3a3d4a","Libre"],["#166534/#4ade80","Sélectionné"],["#450a0a/#ef4444","Occupé (✗)"]].map(([bg,label]) => {
          const [fill,border] = bg.split("/");
          return <span key={label} style={{ display:"flex", alignItems:"center", gap:5, fontSize:10.5, color:"#8b8fa8" }}>
            <span style={{ width:10, height:10, borderRadius:3, background:fill, border:`1.5px solid ${border}`, display:"inline-block" }}/>
            {label}
          </span>;
        })}
      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════
   PHOTO UPLOADER COMPONENT
═══════════════════════════════════════════ */
const PhotoUploader = ({ photos, onAdd, onRemove, uploading, label = "Ajouter des photos du véhicule" }) => {
  const inputRef = useRef();
  return (
    <div>
      {photos.length > 0 && (
        <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:8, marginBottom:10 }}>
          {photos.map((url, i) => (
            <div key={i} style={{ position:"relative", borderRadius:8, overflow:"hidden", border:"0.5px solid #2a2d38", aspectRatio:"4/3", background:"#1a1c25" }}>
              <img src={getPhotoUrl(url)} alt={`${i+1}`} style={{ width:"100%", height:"100%", objectFit:"cover" }} onError={e=>{ e.target.style.display="none"; }} />
              <button onClick={() => onRemove(i)} style={{ position:"absolute", top:5, right:5, width:22, height:22, borderRadius:"50%", background:"rgba(0,0,0,0.7)", border:"none", color:"#f87171", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}>
                <XIcon />
              </button>
              {i === 0 && (
                <span style={{ position:"absolute", bottom:5, left:5, fontSize:9, fontWeight:700, background:"rgba(74,222,128,0.85)", color:"#0f1117", padding:"2px 7px", borderRadius:10, textTransform:"uppercase", letterSpacing:0.5 }}>
                  Principale
                </span>
              )}
              {i === 1 && (
                <span style={{ position:"absolute", bottom:5, left:5, fontSize:9, fontWeight:700, background:"rgba(96,165,250,0.85)", color:"#0f1117", padding:"2px 7px", borderRadius:10, textTransform:"uppercase", letterSpacing:0.5 }}>
                  Intérieur
                </span>
              )}
            </div>
          ))}
        </div>
      )}
      <input ref={inputRef} type="file" accept="image/*" multiple style={{ display:"none" }} onChange={e => onAdd(Array.from(e.target.files))} />
      <button onClick={() => inputRef.current.click()} disabled={uploading} style={{ width:"100%", padding:"14px", borderRadius:10, border:"1.5px dashed #2a2d38", background:"rgba(255,255,255,0.01)", color: uploading ? "#4a4d5a" : "#8b8fa8", cursor: uploading ? "not-allowed" : "pointer", fontFamily:"inherit", fontSize:13, display:"flex", alignItems:"center", justifyContent:"center", gap:8 }}
        onMouseEnter={e=>{ if(!uploading){ e.currentTarget.style.borderColor="#a78bfa"; e.currentTarget.style.color="#a78bfa"; }}}
        onMouseLeave={e=>{ e.currentTarget.style.borderColor="#2a2d38"; e.currentTarget.style.color="#8b8fa8"; }}>
        {uploading ? <><Spinner/>Envoi en cours…</> : <><CameraIcon /> {label}</>}
      </button>
      <div style={{ fontSize:11, color:"#4a4d5a", marginTop:6, textAlign:"center" }}>
        JPG, PNG · Max 5 Mo par photo · La 1ère = extérieur (couverture), la 2ème = intérieur
      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════
   RENTAL CAR CARD — with photo carousel
═══════════════════════════════════════════ */
const RentalCarCard = ({ car, onDelete }) => {
  const [photoIdx, setPhotoIdx] = useState(0);
  const photos = car.photos ?? [];
  const mainPhoto = getPhotoUrl(photos[photoIdx]);

  const prevPhoto = (e) => {
    e.stopPropagation();
    setPhotoIdx(i => (i - 1 + photos.length) % photos.length);
  };
  const nextPhoto = (e) => {
    e.stopPropagation();
    setPhotoIdx(i => (i + 1) % photos.length);
  };

  const fuelColor = { Essence:"#f87171", Diesel:"#fbbf24", Hybride:"#4ade80", "Électrique":"#60a5fa", GPL:"#a78bfa" };
  return (
    <div style={{ background:"#1a1c25", border:"0.5px solid #2a2d38", borderRadius:12, overflow:"hidden" }} className="trip-card">
      <div style={{ height:140, background:"#13151b", position:"relative", overflow:"hidden" }}>
        {mainPhoto ? (
          <img src={mainPhoto} alt={`${car.brand} ${car.model}`} style={{ width:"100%", height:"100%", objectFit:"cover" }}
            onError={e=>{ e.target.style.display="none"; e.target.parentElement.querySelector(".no-photo-fallback").style.display="flex"; }} />
        ) : null}
        <div className="no-photo-fallback" style={{ width:"100%", height:"100%", display: mainPhoto ? "none" : "flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:8, position:"absolute", inset:0 }}>
          <span style={{ fontSize:36 }}>🚗</span>
          <span style={{ fontSize:11, color:"#4a4d5a" }}>Pas de photo</span>
        </div>

        {photos.length > 1 && (
          <>
            <button onClick={prevPhoto} style={{ position:"absolute", left:6, top:"50%", transform:"translateY(-50%)", width:26, height:26, borderRadius:"50%", background:"rgba(0,0,0,0.65)", border:"none", color:"#e8e9ed", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", zIndex:2 }}>
              <ChevLeftIcon />
            </button>
            <button onClick={nextPhoto} style={{ position:"absolute", right:6, top:"50%", transform:"translateY(-50%)", width:26, height:26, borderRadius:"50%", background:"rgba(0,0,0,0.65)", border:"none", color:"#e8e9ed", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", zIndex:2 }}>
              <ChevRightIcon />
            </button>
            <div style={{ position:"absolute", bottom:8, left:"50%", transform:"translateX(-50%)", display:"flex", gap:4, zIndex:2 }}>
              {photos.map((_, i) => (
                <span key={i} onClick={e => { e.stopPropagation(); setPhotoIdx(i); }} style={{ width: i === photoIdx ? 14 : 6, height:6, borderRadius:3, background: i === photoIdx ? "#e8e9ed" : "rgba(255,255,255,0.4)", cursor:"pointer", transition:"width 0.2s, background 0.2s" }} />
              ))}
            </div>
            <span style={{ position:"absolute", top:8, right:8, fontSize:10, fontWeight:700, background:"rgba(0,0,0,0.75)", color:"#c8cad8", padding:"2px 8px", borderRadius:10 }}>
              {photoIdx + 1}/{photos.length}
            </span>
          </>
        )}

        <div style={{ position:"absolute", top:8, left:8 }}>
          <Badge variant={car.status === "available" ? "success" : "warning"}>
            {car.status === "available" ? "Disponible" : car.status ?? "Actif"}
          </Badge>
        </div>

        {/* Delete button */}
        <button
          onClick={e => { e.stopPropagation(); onDelete(car); }}
          style={{ position:"absolute", top:8, right:photos.length > 1 ? 60 : 8, width:28, height:28, borderRadius:"50%", background:"rgba(248,113,113,0.85)", border:"none", color:"#fff", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", zIndex:3 }}
          title="Supprimer ce véhicule"
        >
          <TrashIcon />
        </button>
      </div>
      <div style={{ padding:"14px 16px" }}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:6, gap:8 }}>
          <div style={{ minWidth:0 }}>
            <span style={{ fontSize:14, fontWeight:700, color:"#e8e9ed", letterSpacing:-0.3 }}>{car.brand} {car.model}</span>
            {car.year && <span style={{ fontSize:11, color:"#8b8fa8", marginLeft:7 }}>{car.year}</span>}
          </div>
          <span style={{ fontFamily:"'DM Mono',monospace", fontSize:13, fontWeight:700, color:"#a78bfa", flexShrink:0 }}>
            {Number(car.dailyPrice).toLocaleString()} <span style={{ fontSize:10, opacity:0.6 }}>MGA/j</span>
          </span>
        </div>
        <div style={{ display:"flex", flexWrap:"wrap", gap:5, marginBottom:10 }}>
          {car.fuelType && <span style={{ fontSize:10.5, display:"flex", alignItems:"center", gap:4, color: fuelColor[car.fuelType] ?? "#8b8fa8", background:"rgba(255,255,255,0.04)", padding:"3px 8px", borderRadius:6 }}><FuelIcon /> {car.fuelType}</span>}
          {car.seats && <span style={{ fontSize:10.5, color:"#8b8fa8", background:"rgba(255,255,255,0.04)", padding:"3px 8px", borderRadius:6 }}>👥 {car.seats} places</span>}
          {car.licensePlate && <span style={{ fontSize:10.5, color:"#60a5fa", fontFamily:"'DM Mono',monospace", background:"rgba(96,165,250,0.08)", padding:"3px 8px", borderRadius:6, letterSpacing:1 }}>{car.licensePlate}</span>}
          {car.city && <span style={{ fontSize:10.5, color:"#a78bfa", background:"rgba(167,139,250,0.08)", padding:"3px 8px", borderRadius:6, display:"flex", alignItems:"center", gap:3 }}><LocationIcon /> {car.city}</span>}
        </div>
        {car.features?.length > 0 && (
          <div style={{ display:"flex", flexWrap:"wrap", gap:4, marginBottom:8 }}>
            {car.features.slice(0,4).map(f => (
              <span key={f} style={{ fontSize:10, color:"#8b8fa8", background:"#1e2029", padding:"2px 7px", borderRadius:5, display:"flex", alignItems:"center", gap:3 }}><CheckIcon /> {f}</span>
            ))}
            {car.features.length > 4 && <span style={{ fontSize:10, color:"#4a4d5a" }}>+{car.features.length-4}</span>}
          </div>
        )}
        {car.description && (
          <div style={{ fontSize:11.5, color:"#8b8fa8", lineHeight:1.5, borderTop:"0.5px solid #2a2d38", paddingTop:8, marginTop:4, display:"-webkit-box", WebkitLineClamp:2, WebkitBoxOrient:"vertical", overflow:"hidden" }}>
            {car.description}
          </div>
        )}
        <div style={{ marginTop:10, display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <span style={{ fontSize:11, color:"#4a4d5a", display:"flex", alignItems:"center", gap:4 }}>
            <StarIcon /> {car.bookings ?? 0} réservation{(car.bookings ?? 0) !== 1 ? "s" : ""}
          </span>
        </div>
      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════
   RENTAL PAGE
═══════════════════════════════════════════ */
const RentalPage = ({ onRefresh, cities = [] }) => {
  const [cars,        setCars]        = useState([]);
  const [bookings,    setBookings]    = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [showForm,    setShowForm]    = useState(false);
  const [submitting,  setSubmitting]  = useState(false);
  const [uploading,   setUploading]   = useState(false);
  const [toast,       setToast]       = useState(null);
  const [activeTab,   setActiveTab]   = useState("cars");
  const [createdCarId,setCreatedCarId]= useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null); // { type: "car"|"booking", item }
  const [deleting,     setDeleting]     = useState(false);
  const [form, setForm] = useState({
    brand:"", model:"", year:"", fuelType:"", seats:"", dailyPrice:"",
    licensePlate:"", description:"", features:[], photos:[], city:"",
  });

  const showToast = (type, msg) => { setToast({ type, msg }); setTimeout(() => setToast(null), 3500); };

  const loadCars = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get("/transporter/rentals");
      // Tri du plus récent au plus ancien
      setCars((r.data || []).sort((a,b) => new Date(b.createdAt||0) - new Date(a.createdAt||0)));
    } catch {}
    setLoading(false);
  }, []);

  const loadBookings = useCallback(async () => {
    try {
      const r = await api.get("/transporter/rental-bookings");
      // Tri du plus récent au plus ancien
      setBookings((r.data || []).sort((a,b) => new Date(b.createdAt||0) - new Date(a.createdAt||0)));
    } catch {}
  }, []);

  useEffect(() => { loadCars(); loadBookings(); }, [loadCars, loadBookings]);

  const toggleFeature = (f) => {
    setForm(prev => ({ ...prev, features: prev.features.includes(f) ? prev.features.filter(x => x !== f) : [...prev.features, f] }));
  };

  const handlePhotoUpload = async (files) => {
    if (!createdCarId) { showToast("error", "Créez d'abord le véhicule pour uploader les photos."); return; }
    setUploading(true);
    for (const file of files) {
      try {
        const fd = new FormData();
        fd.append("photo", file);
        const r = await api.post(`/transporter/rentals/${createdCarId}/photos`, fd, { headers: { "Content-Type": "multipart/form-data" } });
        setForm(prev => ({ ...prev, photos: [...prev.photos, r.data.photoUrl] }));
        setCars(prev => prev.map(c => c.id === createdCarId ? { ...c, photos: [...(c.photos ?? []), r.data.photoUrl] } : c));
      } catch { showToast("error", `Erreur upload : ${file.name}`); }
    }
    setUploading(false);
  };

  const handlePhotoRemove = (idx) => { setForm(prev => ({ ...prev, photos: prev.photos.filter((_, i) => i !== idx) })); };

  const submitCar = async () => {
    if (!form.brand.trim())           return showToast("error", "La marque est requise.");
    if (!form.model.trim())           return showToast("error", "Le modèle est requis.");
    if (!form.dailyPrice || form.dailyPrice <= 0) return showToast("error", "Prix journalier invalide.");
    if (!form.seats || form.seats <= 0)           return showToast("error", "Nombre de places invalide.");
    setSubmitting(true);
    try {
      const payload = {
        brand:form.brand.trim(), model:form.model.trim(),
        year:form.year?Number(form.year):null,
        fuelType:form.fuelType||null,
        seats:Number(form.seats),
        dailyPrice:Number(form.dailyPrice),
        licensePlate:form.licensePlate.trim()||null,
        description:form.description.trim()||null,
        features:form.features,
        photos:[],
        city: form.city || null,
      };
      const r = await api.post("/transporter/rentals", payload);
      setCreatedCarId(r.data.id);
      setCars(prev => [r.data, ...prev]);
      showToast("success", "Véhicule créé ! Vous pouvez maintenant uploader les photos.");
    } catch { showToast("error", "Erreur lors de la création du véhicule."); }
    setSubmitting(false);
  };

  const closeForm = () => {
    setShowForm(false); setCreatedCarId(null);
    setForm({ brand:"", model:"", year:"", fuelType:"", seats:"", dailyPrice:"", licensePlate:"", description:"", features:[], photos:[], city:"" });
    loadCars(); onRefresh();
  };

  // ── Delete handlers ──
  const confirmDelete = async () => {
    if (!deleteTarget) return;
    setDeleting(true);
    try {
      if (deleteTarget.type === "car") {
        await api.delete(`/transporter/rentals/${deleteTarget.item.id}`);
        setCars(prev => prev.filter(c => c.id !== deleteTarget.item.id));
        showToast("success", "Véhicule supprimé.");
      } else if (deleteTarget.type === "rental-booking") {
        await api.delete(`/transporter/rental-bookings/${deleteTarget.item.id}`);
        setBookings(prev => prev.filter(b => b.id !== deleteTarget.item.id));
        showToast("success", "Réservation supprimée.");
      }
      setDeleteTarget(null);
    } catch {
      showToast("error", "Erreur lors de la suppression.");
    }
    setDeleting(false);
  };

  const bookingStatusVariant = st => ({ PENDING:"warning", CONFIRMED:"success", CANCELLED:"danger" }[(st??"").toUpperCase()] ?? "neutral");
  const bookingStatusLabel   = st => ({ PENDING:"En attente", CONFIRMED:"Confirmé", CANCELLED:"Annulé" }[(st??"").toUpperCase()] ?? st);

  return (
    <div>
      <div style={s.pageHeader}>
        <div>
          <h1 style={s.pageTitle}>Location de véhicules</h1>
          <p style={s.pageSub}>{cars.length} véhicule{cars.length !== 1 ? "s" : ""} enregistré{cars.length !== 1 ? "s" : ""}</p>
        </div>
        <button style={{ ...s.primaryBtn, background:"#a78bfa", color:"#0f1117" }} onClick={() => setShowForm(true)} className="prim-btn">
          <PlusIcon /> Ajouter un véhicule
        </button>
      </div>

      {/* Tabs */}
      <div style={{ display:"flex", gap:4, marginBottom:20, background:"#13151b", borderRadius:10, padding:4, width:"fit-content", maxWidth:"100%" }}>
        {[["cars","🚗 Véhicules"],["bookings","📅 Réservations"]].map(([tab, label]) => (
          <button key={tab} onClick={() => setActiveTab(tab)} style={{ padding:"8px 14px", borderRadius:8, border:"none", fontFamily:"inherit", fontSize:13, fontWeight:600, cursor:"pointer", background: activeTab === tab ? "#a78bfa" : "transparent", color: activeTab === tab ? "#0f1117" : "#8b8fa8", whiteSpace:"nowrap" }}>{label}</button>
        ))}
      </div>

      {activeTab === "cars" && (
        loading ? <div style={{ textAlign:"center", padding:"40px 0", color:"#8b8fa8" }}>Chargement…</div>
        : cars.length === 0 ? (
          <div style={s.emptyState}>
            <div style={{ fontSize:42, marginBottom:12 }}>🚗</div>
            <div style={{ fontSize:14, color:"#8b8fa8", marginBottom:12 }}>Aucun véhicule enregistré</div>
            <button style={{ ...s.primaryBtn, background:"#a78bfa" }} onClick={() => setShowForm(true)} className="prim-btn"><PlusIcon /> Ajouter votre premier véhicule</button>
          </div>
        ) : (
          <div className="cards-grid">
            {cars.map((car, i) => (
              <RentalCarCard key={car.id ?? i} car={car} onDelete={item => setDeleteTarget({ type:"car", item })} />
            ))}
          </div>
        )
      )}

      {activeTab === "bookings" && (
        bookings.length === 0
          ? <div style={s.emptyState}><div style={{ fontSize:36, marginBottom:10 }}>📅</div><div style={{ fontSize:14, color:"#8b8fa8" }}>Aucune réservation pour l'instant</div></div>
          : (
            <div style={s.card}>
              <div style={{ overflowX:"auto", WebkitOverflowScrolling:"touch" }}>
                <table style={s.table}>
                  <thead><tr>{["Véhicule","Client","Du","Au","Jours","Total","Lieu","Statut",""].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
                  <tbody>
                    {bookings.map((b, i) => (
                      <tr key={b.id ?? i} className="brow">
                        <td style={s.td}>
                          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                            {b.car?.photo ? <img src={getPhotoUrl(b.car.photo)} alt="" style={{ width:32, height:32, borderRadius:6, objectFit:"cover", flexShrink:0 }} /> : <span style={{ fontSize:20 }}>🚗</span>}
                            <span style={{ fontSize:13, fontWeight:600, color:"#e8e9ed", whiteSpace:"nowrap" }}>{b.car?.brand} {b.car?.model}</span>
                          </div>
                        </td>
                        <td style={{ ...s.td, whiteSpace:"nowrap" }}>{b.customer?.name ?? "—"}</td>
                        <td style={{ ...s.td, fontFamily:"'DM Mono',monospace", fontSize:12, color:"#8b8fa8", whiteSpace:"nowrap" }}>{b.startDate ?? "—"}</td>
                        <td style={{ ...s.td, fontFamily:"'DM Mono',monospace", fontSize:12, color:"#8b8fa8", whiteSpace:"nowrap" }}>{b.endDate ?? "—"}</td>
                        <td style={s.td}><Badge variant="neutral">{b.days ?? "—"} j</Badge></td>
                        <td style={{ ...s.td, whiteSpace:"nowrap" }}><span style={{ fontFamily:"'DM Mono',monospace", color:"#a78bfa", fontWeight:700 }}>{Number(b.totalPrice ?? 0).toLocaleString()} MGA</span></td>
                        <td style={{ ...s.td, fontSize:12, color:"#60a5fa", whiteSpace:"nowrap" }}>{b.pickupLocation ?? "—"}</td>
                        <td style={s.td}><Badge variant={bookingStatusVariant(b.status)}>{bookingStatusLabel(b.status)}</Badge></td>
                        <td style={s.td}>
                          <button onClick={() => setDeleteTarget({ type:"rental-booking", item:b })} style={{ background:"rgba(248,113,113,0.1)", border:"0.5px solid rgba(248,113,113,0.2)", borderRadius:7, color:"#f87171", cursor:"pointer", padding:"5px 9px", display:"flex", alignItems:"center", gap:4, fontSize:12 }}>
                            <TrashIcon />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )
      )}

      {showForm && (
        <Modal
          title={createdCarId ? "📷 Ajouter des photos" : "🚗 Ajouter un véhicule"}
          subtitle={createdCarId ? "Véhicule créé. Ajoutez une photo extérieure puis intérieure." : "Renseignez les informations du véhicule de location"}
          onClose={closeForm}
          wide
        >
          {!createdCarId ? (
            <>
              <div className="form-grid-2">
                <Field label="Marque *"><input style={inp} type="text" placeholder="Ex : Toyota, Renault…" value={form.brand} onChange={e => setForm({ ...form, brand: e.target.value })} /></Field>
                <Field label="Modèle *"><input style={inp} type="text" placeholder="Ex : Hilux, Duster…" value={form.model} onChange={e => setForm({ ...form, model: e.target.value })} /></Field>
              </div>
              <div className="form-grid-2">
                <Field label="Année"><input style={inp} type="number" placeholder="Ex : 2020" value={form.year} onChange={e => setForm({ ...form, year: e.target.value })} /></Field>
                <Field label="Type de carburant">
                  <select style={sel} value={form.fuelType} onChange={e => setForm({ ...form, fuelType: e.target.value })}>
                    <option value="">Sélectionner…</option>
                    {FUEL_TYPES.map(f => <option key={f} value={f}>{f}</option>)}
                  </select>
                </Field>
              </div>
              <div className="form-grid-2">
                <Field label="Nombre de places *"><input style={inp} type="number" placeholder="Ex : 5" value={form.seats} onChange={e => setForm({ ...form, seats: e.target.value })} /></Field>
                <Field label="Prix journalier (MGA) *"><input style={inp} type="number" placeholder="Ex : 80 000" value={form.dailyPrice} onChange={e => setForm({ ...form, dailyPrice: e.target.value })} /></Field>
              </div>
              <div className="form-grid-2">
                <Field label="Immatriculation (plaque)">
                  <input style={{ ...inp, textTransform:"uppercase", letterSpacing:2, fontFamily:"'DM Mono',monospace" }} type="text" placeholder="Ex : TAM 0001 AA" value={form.licensePlate} onChange={e => setForm({ ...form, licensePlate: e.target.value.toUpperCase() })} />
                </Field>
                <Field label="Ville de disponibilité">
                  <select style={sel} value={form.city} onChange={e => setForm({ ...form, city: e.target.value })}>
                    <option value="">Sélectionner une ville…</option>
                    {cities.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                </Field>
              </div>
              <Field label="Équipements & Options">
                <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
                  {CAR_FEATURES.map(f => (
                    <button key={f} onClick={() => toggleFeature(f)} style={{ fontSize:11.5, padding:"5px 12px", borderRadius:20, border:"0.5px solid", background: form.features.includes(f) ? "rgba(167,139,250,0.15)" : "transparent", color: form.features.includes(f) ? "#a78bfa" : "#8b8fa8", borderColor: form.features.includes(f) ? "#a78bfa" : "#2a2d38", cursor:"pointer", fontFamily:"inherit" }}>
                      {form.features.includes(f) && "✓ "}{f}
                    </button>
                  ))}
                </div>
              </Field>
              <Field label="Description (optionnel)">
                <textarea style={{ ...inp, height:80, resize:"vertical", lineHeight:1.6 }} placeholder="État du véhicule, conditions de location, dépôt de garantie…" value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} />
              </Field>
              <div style={{ background:"rgba(167,139,250,0.07)", border:"0.5px solid rgba(167,139,250,0.2)", borderRadius:9, padding:"10px 14px", marginBottom:4, fontSize:12, color:"#a78bfa", display:"flex", alignItems:"center", gap:7 }}>
                <CommissionBanner type="rental" />
                <InfoIcon /> Vous pourrez ajouter les photos dans l'étape suivante après création.
              </div>
              <div style={{ display:"flex", justifyContent:"flex-end", gap:8, marginTop:20, paddingTop:16, borderTop:"0.5px solid #2a2d38", flexWrap:"wrap" }}>
                <button style={s.ghostBtn} onClick={closeForm}>Annuler</button>
                <button style={{ ...s.primaryBtn, background:"#a78bfa", opacity: submitting ? 0.7 : 1 }} onClick={submitCar} disabled={submitting} className="prim-btn">
                  {submitting ? <><Spinner />Création…</> : <><PlusIcon />Créer le véhicule</>}
                </button>
              </div>
            </>
          ) : (
            <>
              <div style={{ background:"rgba(74,222,128,0.07)", border:"0.5px solid rgba(74,222,128,0.2)", borderRadius:9, padding:"10px 14px", marginBottom:16, fontSize:13, color:"#4ade80", display:"flex", alignItems:"center", gap:8 }}>
                <CheckIcon /> Véhicule créé avec succès !
              </div>
              <div style={{ background:"rgba(96,165,250,0.07)", border:"0.5px solid rgba(96,165,250,0.2)", borderRadius:9, padding:"10px 14px", marginBottom:20, fontSize:12, color:"#60a5fa", display:"flex", alignItems:"flex-start", gap:8 }}>
                <InfoIcon style={{ flexShrink:0, marginTop:1 }} />
                <span>Ajoutez d'abord une photo <strong>extérieure</strong> (couverture), puis une photo <strong>intérieure</strong> du véhicule pour le rendre plus attractif.</span>
              </div>
              <PhotoUploader
                photos={form.photos}
                onAdd={handlePhotoUpload}
                onRemove={handlePhotoRemove}
                uploading={uploading}
                label="Ajouter des photos (extérieur + intérieur)"
              />
              <div style={{ display:"flex", justifyContent:"flex-end", gap:8, marginTop:20, paddingTop:16, borderTop:"0.5px solid #2a2d38" }}>
                <button style={{ ...s.primaryBtn, background:"#a78bfa" }} onClick={closeForm} className="prim-btn"><CheckIcon /> Terminer</button>
              </div>
            </>
          )}
        </Modal>
      )}

      {deleteTarget && (
        <ConfirmDeleteModal
          title={deleteTarget.type === "car" ? "Supprimer ce véhicule ?" : "Supprimer cette réservation ?"}
          message={
            deleteTarget.type === "car"
              ? `Le véhicule "${deleteTarget.item.brand} ${deleteTarget.item.model}" sera définitivement supprimé avec toutes ses réservations associées.`
              : `La réservation de ${deleteTarget.item.customer?.name ?? "ce client"} sera définitivement supprimée.`
          }
          onConfirm={confirmDelete}
          onCancel={() => setDeleteTarget(null)}
          loading={deleting}
        />
      )}
      <Toast toast={toast} />
    </div>
  );
};

/* ═══════════════════════════════════════════
   TRIPS PAGE
═══════════════════════════════════════════ */
const TripsPage = ({ trips, onAdd, onDeleteTrip }) => {
  // Tri du plus récent au plus ancien
  const sorted = [...trips].sort((a,b) => new Date(b.departureTime||b.createdAt||0) - new Date(a.departureTime||a.createdAt||0));

  return (
    <div>
      <div style={s.pageHeader}>
        <div>
          <h1 style={s.pageTitle}>Mes trajets</h1>
          <p style={s.pageSub}>{trips.length} trajet{trips.length!==1?"s":""} enregistré{trips.length!==1?"s":""}</p>
        </div>
        <button style={s.primaryBtn} onClick={onAdd} className="prim-btn"><PlusIcon /> Nouveau trajet</button>
      </div>
      {sorted.length===0 ? (
        <div style={s.emptyState}>
          <div style={{ fontSize:36, marginBottom:10 }}>🚌</div>
          <div style={{ fontSize:14, color:"#8b8fa8", marginBottom:12 }}>Aucun trajet pour l'instant</div>
          <button style={s.primaryBtn} onClick={onAdd} className="prim-btn"><PlusIcon /> Créer un trajet</button>
        </div>
      ) : (
        <div className="cards-grid">
          {sorted.map(t => (
            <div key={t.id} style={{ ...s.tripCard, position:"relative" }} className="trip-card">
              {/* Delete button */}
              <button
                onClick={() => onDeleteTrip(t)}
                style={{ position:"absolute", top:10, right:10, width:26, height:26, borderRadius:"50%", background:"rgba(248,113,113,0.1)", border:"0.5px solid rgba(248,113,113,0.25)", color:"#f87171", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}
                title="Supprimer ce trajet"
              >
                <TrashIcon />
              </button>
              <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:10, paddingRight:32 }}>
                <span style={{ fontFamily:"'DM Mono',monospace", fontSize:14, fontWeight:700, color:"#4ade80" }}>{Number(t.price).toLocaleString()} MGA</span>
                <Badge variant="info">{t.seats} places</Badge>
              </div>
              {t.tripType && <div style={{ marginBottom:8 }}><Badge variant={t.tripType==="Taxi-brousse"?"warning":"success"}>{t.tripType}</Badge></div>}
              <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:8, flexWrap:"wrap" }}>
                <span style={s.cityTag}>{t.departure}</span>
                <span style={{ color:"#4a4d5a" }}><ArrowIcon /></span>
                <span style={s.cityTag}>{t.arrival}</span>
              </div>
              {t.stationName && <div style={{ display:"flex", alignItems:"center", gap:4, fontSize:11, color:"#60a5fa", marginBottom:6 }}><LocationIcon /> {t.stationName}</div>}
              <div style={{ display:"flex", alignItems:"center", gap:5, fontSize:11, color:"#8b8fa8" }}><ClockIcon /> {t.departureTime}</div>
              {t.tripType === "Covoiturage" && (
                <div style={{ display:"flex", alignItems:"center", gap:4, fontSize:10.5, color:"#4ade80", marginTop:6 }}><ShieldIcon /> Annulation gratuite 12h avant</div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

/* ═══════════════════════════════════════════
   BOOKINGS PAGE
   • Filtre les réservations dont le trajet est déjà parti
   • Tri du plus récent au plus ancien
   • Pagination "Voir plus"
   • Suppression individuelle
═══════════════════════════════════════════ */
const BOOKINGS_PER_PAGE = 10;

const BookingsPage = ({ trips, onDeleteBooking }) => {
  const [visibleCount, setVisibleCount] = useState(BOOKINGS_PER_PAGE);
  const now = new Date();

  // Flatten + filtre expiré + tri plus récent en premier
  const all = trips
    .flatMap(t => (t.bookings || []).map(b => ({ ...b, trip: t })))
    .filter(b => {
      // Exclure les réservations dont la date de départ est passée
      const depTime = b.trip?.departureTime;
      if (!depTime) return true; // pas de date → on garde
      return new Date(depTime) >= now;
    })
    .sort((a, b) => {
      const da = a.createdAt ? new Date(a.createdAt) : new Date(0);
      const db = b.createdAt ? new Date(b.createdAt) : new Date(0);
      return db - da;
    });

  const visible   = all.slice(0, visibleCount);
  const hasMore   = visibleCount < all.length;
  const remaining = all.length - visibleCount;

  const statusVariant = st => ({ CONFIRMED:"success", SUCCESS:"success", PENDING:"warning", CANCELLED:"danger" }[(st ?? "").toUpperCase()] || "neutral");
  const statusLabel   = b => { const pay = b.payment?.status?.toUpperCase(), bk = (b.status ?? "").toUpperCase(); if (pay === "SUCCESS" || bk === "CONFIRMED") return "Confirmé"; if (bk === "CANCELLED") return "Annulé"; return "En attente"; };
  const variant       = b => { const pay = b.payment?.status?.toUpperCase(), bk = (b.status ?? "").toUpperCase(); if (pay === "SUCCESS" || bk === "CONFIRMED") return "success"; if (bk === "CANCELLED") return "danger"; return "warning"; };

  const DeleteBtn = ({ b }) => (
    <button
      onClick={() => onDeleteBooking(b)}
      style={{ background:"rgba(248,113,113,0.1)", border:"0.5px solid rgba(248,113,113,0.2)", borderRadius:7, color:"#f87171", cursor:"pointer", padding:"5px 9px", display:"flex", alignItems:"center", gap:4, fontSize:12 }}
      title="Supprimer cette réservation"
    >
      <TrashIcon />
    </button>
  );

  /* Carte mobile */
  const MobileBookingCard = ({ b }) => (
    <div style={{ background:"#1a1c25", border:"0.5px solid #2a2d38", borderRadius:10, padding:"14px 16px", marginBottom:10, position:"relative" }}>
      <button
        onClick={() => onDeleteBooking(b)}
        style={{ position:"absolute", top:10, right:10, width:26, height:26, borderRadius:"50%", background:"rgba(248,113,113,0.1)", border:"0.5px solid rgba(248,113,113,0.2)", color:"#f87171", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}
      >
        <TrashIcon />
      </button>
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:10, paddingRight:32 }}>
        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
          <Avatar name={b.fullName} color="#60a5fa" />
          <div>
            <span style={{ fontSize:13, fontWeight:600, color:"#e8e9ed", display:"block" }}>{b.fullName || "—"}</span>
            {b.phone
              ? <a href={`tel:${b.phone}`} style={{ fontSize:12, color:"#4ade80", fontFamily:"'DM Mono',monospace", textDecoration:"none", display:"flex", alignItems:"center", gap:4, marginTop:2 }}>
                  📞 {b.phone}
                </a>
              : <span style={{ fontSize:11, color:"#4a4d5a", marginTop:2, display:"block" }}>Pas de numéro</span>
            }
          </div>
        </div>
        <Badge variant={variant(b)}>{statusLabel(b)}</Badge>
      </div>

      <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:8 }}>
        <span style={s.cityTag}>{b.trip.departure}</span>
        <ArrowIcon />
        <span style={s.cityTag}>{b.trip.arrival}</span>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, fontSize:12, color:"#8b8fa8" }}>
        {b.seatNumber && (
          <div>Siège <span style={{ color:"#4ade80", fontWeight:700 }}>#{String(b.seatNumber).padStart(2, "0")}</span></div>
        )}
        <div style={{ fontFamily:"'DM Mono',monospace" }}>{b.trip.departureTime || "—"}</div>
        {b.payment?.amount && (
          <div style={{ color:"#4ade80", fontFamily:"'DM Mono',monospace", fontWeight:700 }}>{Number(b.payment.amount).toLocaleString()} MGA</div>
        )}
        {b.reference && (
          <div style={{ color:"#c8cad8", fontFamily:"'DM Mono',monospace", fontSize:11 }}>{b.reference}</div>
        )}
        {b.createdAt && (
          <div style={{ color:"#4a4d5a", fontSize:11, gridColumn:"span 2" }}>
            🕐 {new Date(b.createdAt).toLocaleString("fr-FR", { day:"2-digit", month:"2-digit", year:"numeric", hour:"2-digit", minute:"2-digit" })}
          </div>
        )}
      </div>
    </div>
  );

  return (
    <div>
      <div style={s.pageHeader}>
        <div>
          <h1 style={s.pageTitle}>Réservations</h1>
          <p style={s.pageSub}>
            {all.length} réservation{all.length !== 1 ? "s" : ""} à venir · {all.filter(b => (b.payment?.status ?? "").toUpperCase() === "SUCCESS" || b.status === "CONFIRMED").length} confirmée(s)
          </p>
        </div>
      </div>

      {/* Info filtre */}
      <div style={{ display:"flex", alignItems:"center", gap:7, background:"rgba(96,165,250,0.06)", border:"0.5px solid rgba(96,165,250,0.15)", borderRadius:9, padding:"9px 14px", marginBottom:16, fontSize:12, color:"#60a5fa" }}>
        <InfoIcon /> Seules les réservations dont le départ n'a pas encore eu lieu sont affichées (trajets à venir).
      </div>

      {all.length === 0 ? (
        <div style={s.emptyState}>
          <div style={{ fontSize:36, marginBottom:10 }}>👥</div>
          <div style={{ fontSize:14, color:"#8b8fa8" }}>Aucune réservation à venir pour l'instant</div>
        </div>
      ) : (
        <>
          {/* TABLE DESKTOP */}
          <div style={s.card} className="desktop-only">
            <div style={{ overflowX:"auto", WebkitOverflowScrolling:"touch" }}>
              <table style={s.table}>
                <thead>
                  <tr>
                    {["Passager","Téléphone","Siège","Trajet","Gare","Date/Heure","Réservé le","Référence","Paiement","Statut",""].map(h => (
                      <th key={h} style={s.th}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {visible.map((b, i) => (
                    <tr key={b.id ?? i} className="brow">
                      <td style={s.td}>
                        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                          <Avatar name={b.fullName} color="#60a5fa" />
                          <span style={{ fontSize:13, fontWeight:600, color:"#e8e9ed", whiteSpace:"nowrap" }}>{b.fullName || "—"}</span>
                        </div>
                      </td>
                      <td style={s.td}>
                        {b.phone
                          ? <a href={`tel:${b.phone}`} style={{ fontFamily:"'DM Mono',monospace", fontSize:12, color:"#4ade80", textDecoration:"none", whiteSpace:"nowrap", display:"flex", alignItems:"center", gap:5 }}>
                              📞 {b.phone}
                            </a>
                          : <span style={{ color:"#4a4d5a", fontSize:12 }}>—</span>
                        }
                      </td>
                      <td style={s.td}>
                        {b.seatNumber
                          ? <span style={{ fontFamily:"'DM Mono',monospace", fontSize:13, fontWeight:700, color:"#4ade80", background:"rgba(74,222,128,0.1)", padding:"3px 9px", borderRadius:6 }}>
                              #{String(b.seatNumber).padStart(2, "0")}
                            </span>
                          : <span style={{ color:"#4a4d5a", fontSize:12 }}>—</span>
                        }
                      </td>
                      <td style={s.td}>
                        <div style={{ display:"flex", alignItems:"center", gap:5, flexWrap:"nowrap" }}>
                          <span style={s.cityTag}>{b.trip.departure}</span>
                          <span style={{ color:"#2a2d38", fontSize:10 }}><ArrowIcon /></span>
                          <span style={s.cityTag}>{b.trip.arrival}</span>
                        </div>
                      </td>
                      <td style={{ ...s.td, fontSize:11, color:"#60a5fa", whiteSpace:"nowrap" }}>{b.trip.stationName || "—"}</td>
                      <td style={{ ...s.td, color:"#8b8fa8", fontSize:12, fontFamily:"'DM Mono',monospace", whiteSpace:"nowrap" }}>{b.trip.departureTime || "—"}</td>
                      <td style={{ ...s.td, color:"#8b8fa8", fontSize:12, fontFamily:"'DM Mono',monospace", whiteSpace:"nowrap" }}>
                        {b.createdAt
                          ? new Date(b.createdAt).toLocaleString("fr-FR", { day:"2-digit", month:"2-digit", year:"numeric", hour:"2-digit", minute:"2-digit" })
                          : "—"}
                      </td>
                      <td style={{ ...s.td, fontFamily:"'DM Mono',monospace", fontSize:12, color:"#c8cad8", letterSpacing:0.5, whiteSpace:"nowrap" }}>{b.reference || "—"}</td>
                      <td style={s.td}>
                        <div style={{ display:"flex", flexDirection:"column", gap:2 }}>
                          <Badge variant={statusVariant(b.payment?.status)}>
                            {b.payment?.status === "SUCCESS" ? "Payé" : b.payment?.status === "PENDING" ? "En attente" : b.payment?.status ?? "—"}
                          </Badge>
                          {b.payment?.amount && (
                            <span style={{ fontSize:11, color:"#4a4d5a", fontFamily:"'DM Mono',monospace", whiteSpace:"nowrap" }}>{Number(b.payment.amount).toLocaleString()} MGA</span>
                          )}
                          {b.payment?.operator && (
                            <span style={{ fontSize:10, color:"#8b8fa8" }}>{b.payment.operator}</span>
                          )}
                        </div>
                      </td>
                      <td style={s.td}><Badge variant={variant(b)}>{statusLabel(b)}</Badge></td>
                      <td style={s.td}><DeleteBtn b={b} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {hasMore && (
              <div style={{ textAlign:"center", paddingTop:16, borderTop:"0.5px solid #2a2d38", marginTop:4 }}>
                <button onClick={() => setVisibleCount(c => c + BOOKINGS_PER_PAGE)} style={{ ...s.ghostBtn, fontSize:13, padding:"9px 24px" }}>
                  Voir plus · {remaining} restante{remaining > 1 ? "s" : ""} ↓
                </button>
              </div>
            )}
            {!hasMore && all.length > BOOKINGS_PER_PAGE && (
              <div style={{ textAlign:"center", paddingTop:14, fontSize:12, color:"#4a4d5a" }}>✓ Toutes les réservations affichées</div>
            )}
          </div>

          {/* CARTES MOBILE */}
          <div className="mobile-only">
            {visible.map((b, i) => <MobileBookingCard key={b.id ?? i} b={b} />)}
            {hasMore && (
              <button onClick={() => setVisibleCount(c => c + BOOKINGS_PER_PAGE)} style={{ ...s.ghostBtn, width:"100%", justifyContent:"center", marginTop:4, fontSize:13 }}>
                Voir plus · {remaining} restante{remaining > 1 ? "s" : ""} ↓
              </button>
            )}
            {!hasMore && all.length > BOOKINGS_PER_PAGE && (
              <div style={{ textAlign:"center", padding:"12px 0", fontSize:12, color:"#4a4d5a" }}>✓ Toutes les réservations affichées</div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

/* ═══════════════════════════════════════════
   REVENUE PAGE — 93% / 7%
═══════════════════════════════════════════ */
const RevenuePage = ({ stats, onRefresh }) => {
  const [requests,   setRequests]   = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [showForm,   setShowForm]   = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [toast,      setToast]      = useState(null);
  const [form, setForm] = useState({ amount:"", motif:"", nomOperateur:"", numeroOperateur:"", nomCarteSim:"" });

  const showToast = (type,msg) => { setToast({type,msg}); setTimeout(()=>setToast(null),3500); };
  const loadRequests = useCallback(async()=>{ setLoading(true); try{ const r=await api.get("/transporter/payment-requests"); setRequests((r.data||[]).sort((a,b)=>new Date(b.createdAt||0)-new Date(a.createdAt||0))); }catch{} setLoading(false); },[]);
  useEffect(()=>{ loadRequests(); },[loadRequests]);

  const revenueTotal   = Number(stats.revenueTotal??stats.revenue??0);
  const revenuePaye    = Number(stats.revenuePaye??0);
  const revenueRestant = Math.max(0,revenueTotal-revenuePaye);
  const progressPct    = revenueTotal>0?Math.min(100,(revenuePaye/revenueTotal)*100):0;

  const statusVariant = st=>({PENDING:"warning",APPROVED:"success",REJECTED:"danger"}[st?.toUpperCase()]||"neutral");
  const statusLabel   = st=>({PENDING:"En attente",APPROVED:"Approuvé",REJECTED:"Refusé"}[st?.toUpperCase()]||st);

  const submitRequest = async()=>{
    if(!form.amount||Number(form.amount)<=0)   return showToast("error","Montant invalide.");
    if(Number(form.amount)>revenueRestant)     return showToast("error","Montant supérieur au solde disponible.");
    if(!form.nomOperateur)                     return showToast("error","Sélectionnez un opérateur.");
    if(!form.nomCarteSim?.trim())              return showToast("error","Le nom inscrit sur la carte SIM est requis.");
    if(!form.numeroOperateur?.trim()||form.numeroOperateur.trim().length<7) return showToast("error","Numéro invalide.");
    setSubmitting(true);
    try{
      const r=await api.post("/transporter/payment-requests",{ amount:Number(form.amount), motif:form.motif, nomOperateur:form.nomOperateur, numeroOperateur:form.numeroOperateur, nomCarteSim:form.nomCarteSim });
      setRequests(prev=>[r.data,...prev]);
      setForm({amount:"",motif:"",nomOperateur:"",numeroOperateur:"",nomCarteSim:""});
      setShowForm(false);
      showToast("success","Demande envoyée à l'administrateur !");
      onRefresh();
    }catch{ showToast("error","Erreur lors de l'envoi."); }
    setSubmitting(false);
  };

  return (
    <div>
      <div style={s.pageHeader}>
        <div><h1 style={s.pageTitle}>Revenus</h1><p style={s.pageSub}>Suivi de vos gains et demandes de paiement</p></div>
        <button style={s.primaryBtn} onClick={()=>setShowForm(true)} className="prim-btn"><MoneyIcon /> Demander un paiement</button>
      </div>

      <div style={rv.overviewCard}>
        <div style={rv.overviewHeader}>
          <div style={{display:"flex",alignItems:"center",gap:10,minWidth:0}}>
            <div style={rv.overviewIconWrap}><TicketIcon/></div>
            <div style={{minWidth:0}}>
              <div style={rv.overviewLabel}>Revenus générés par les billets</div>
              <div style={rv.overviewSub}>Votre part = 93 % du total des réservations confirmées</div>
            </div>
          </div>
          <Badge variant="info">{stats.bookings??0} réservation{(stats.bookings??0)!==1?"s":""}</Badge>
        </div>

        <div className="rv-numbers-row">
          {[
            {label:"Total généré",value:revenueTotal,color:"#e8e9ed",hint:"Billets confirmés × 93 %"},
            {label:"Déjà perçu",  value:revenuePaye, color:"#4ade80",hint:"Paiements approuvés par l'admin"},
            {label:"Solde disponible",value:revenueRestant,color:"#fbbf24",hint:"En attente de versement",cta:true},
          ].map(({label,value,color,hint,cta},i)=>(
            <div key={i} style={{ padding:"0 0 16px", borderBottom:"0.5px solid #2a2d38", marginBottom:4 }} className="rv-num-block">
              <div style={{fontSize:10.5,color:"#8b8fa8",textTransform:"uppercase",letterSpacing:0.6,fontWeight:600,marginBottom:6}}>{label}</div>
              <div style={{fontFamily:"'DM Mono',monospace",fontSize:20,fontWeight:700,letterSpacing:-1,color}}>{value.toLocaleString()} <span style={{fontSize:11,fontWeight:400,opacity:0.55}}>MGA</span></div>
              <div style={{fontSize:10.5,color:"#4a4d5a",marginTop:5}}>{hint}</div>
              {cta && value>0 && <button style={rv.quickRequestBtn} onClick={()=>setShowForm(true)}>Demander →</button>}
            </div>
          ))}
        </div>

        <div style={rv.progressSection}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:7,flexWrap:"wrap",gap:4}}>
            <span style={rv.progressLabel}><span style={{color:"#4ade80",fontWeight:700}}>{progressPct.toFixed(1)} %</span> déjà perçu</span>
            <span style={{...rv.progressLabel,color:"#4a4d5a",fontFamily:"'DM Mono',monospace",fontSize:11}}>{revenuePaye.toLocaleString()} / {revenueTotal.toLocaleString()} MGA</span>
          </div>
          <div style={rv.progressTrack}><div style={{...rv.progressFill,width:`${progressPct}%`}}/></div>
        </div>
        <div style={rv.infoNote}><span style={{flexShrink:0,marginTop:1}}><InfoIcon/></span>La plateforme retient 7 % sur chaque billet vendu. Votre part (93 %) est versée sur demande, après validation par l'administrateur.</div>
      </div>

      <div className="stats-grid" style={{marginBottom:20}}>
        {[
          {label:"Trajets actifs",  value:stats.trips??0,                         color:"#60a5fa",bg:"rgba(96,165,250,0.1)",  icon:<BusIcon/>},
          {label:"Réservations",    value:stats.bookings??0,                       color:"#fbbf24",bg:"rgba(251,191,36,0.1)",  icon:<UsersIcon/>},
          {label:"Solde disponible",value:`${revenueRestant.toLocaleString()} MGA`,color:"#4ade80",bg:"rgba(74,222,128,0.1)",  icon:<WalletIcon/>},
        ].map(({label,value,color,bg,icon})=>(
          <div key={label} style={s.statCard}>
            <div style={{...s.statIcon,background:bg,color}}>{icon}</div>
            <div style={{...s.statValue,fontSize:17}}>{value}</div>
            <div style={s.statLabel}>{label}</div>
          </div>
        ))}
      </div>

      <div style={s.card}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:4,flexWrap:"wrap",gap:8}}>
          <h2 style={s.cardTitle}>Mes demandes de paiement</h2>
          <Badge variant="neutral">{requests.length} demandes</Badge>
        </div>
        <p style={{fontSize:11,color:"#8b8fa8",marginBottom:16}}>
          {requests.filter(r=>(r.status??"").toUpperCase()==="PENDING").length} en attente ·{" "}
          {requests.filter(r=>(r.status??"").toUpperCase()==="APPROVED").length} approuvée(s)
        </p>
        {loading ? (
          <div style={{textAlign:"center",padding:"32px 0",color:"#8b8fa8"}}>Chargement…</div>
        ) : requests.length===0 ? (
          <div style={{textAlign:"center",padding:"40px 0"}}>
            <div style={{fontSize:32,marginBottom:10}}>💸</div>
            <div style={{fontSize:13,color:"#8b8fa8",marginBottom:14}}>Aucune demande pour l'instant</div>
            <button style={s.primaryBtn} onClick={()=>setShowForm(true)} className="prim-btn"><MoneyIcon/> Faire une demande</button>
          </div>
        ) : (
          <div style={{overflowX:"auto",WebkitOverflowScrolling:"touch"}}>
            <table style={s.table}>
              <thead><tr>{["Date","Montant","Opérateur","Nom SIM","Numéro","Motif","Statut","Code"].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
              <tbody>
                {requests.map((r,i)=>{
                  const status=(r.status??"PENDING").toUpperCase();
                  return (
                    <tr key={r.id??i} className="brow">
                      <td style={{...s.td,color:"#8b8fa8",fontSize:12,fontFamily:"'DM Mono',monospace",whiteSpace:"nowrap"}}>{r.createdAt?new Date(r.createdAt).toLocaleDateString("fr-FR"):"—"}</td>
                      <td style={s.td}><span style={{fontFamily:"'DM Mono',monospace",color:"#fbbf24",fontWeight:700,whiteSpace:"nowrap"}}>{Number(r.amount).toLocaleString()} MGA</span></td>
                      <td style={s.td}><Badge variant="info">{r.nomOperateur||"—"}</Badge></td>
                      <td style={{...s.td,fontSize:12,color:"#e8e9ed",fontWeight:600,whiteSpace:"nowrap"}}>{r.nomCarteSim||"—"}</td>
                      <td style={{...s.td,color:"#8b8fa8",fontSize:12,fontFamily:"'DM Mono',monospace",whiteSpace:"nowrap"}}>{r.numeroOperateur||"—"}</td>
                      <td style={{...s.td,color:"#8b8fa8",fontSize:12,maxWidth:120}}><span style={{display:"block",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={r.motif||""}>{r.motif||"—"}</span></td>
                      <td style={s.td}><Badge variant={statusVariant(r.status)}>{statusLabel(r.status??"PENDING")}</Badge></td>
                      <td style={s.td}>
                        {status==="APPROVED"?(
                          <div style={{display:"flex",alignItems:"center",gap:6}}>
                            <span style={{width:6,height:6,borderRadius:"50%",background:"#4ade80",flexShrink:0}}/>
                            <span style={{fontFamily:"'DM Mono',monospace",fontSize:13,color:"#4ade80",fontWeight:700,letterSpacing:0.5}}>{r.codePaiement||"—"}</span>
                          </div>
                        ):status==="PENDING"?(
                          <span style={{fontSize:11,color:"#8b8fa8",display:"flex",alignItems:"center",gap:5,whiteSpace:"nowrap"}}>
                            <span style={{display:"inline-block",width:8,height:8,borderRadius:"50%",border:"1.5px solid #fbbf24",animation:"pulse 1.5s ease-in-out infinite"}}/>En traitement
                          </span>
                        ):<span style={{color:"#4a4d5a",fontSize:12}}>—</span>}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {showForm&&(
        <Modal title="Demande de paiement" subtitle="Soumise à l'administrateur pour validation" onClose={()=>setShowForm(false)}
          footer={
            <div style={{display:"flex",justifyContent:"flex-end",gap:8,flexWrap:"wrap"}}>
              <button style={s.ghostBtn} onClick={()=>setShowForm(false)}>Annuler</button>
              <button style={{...s.primaryBtn,opacity:submitting?0.7:1}} onClick={submitRequest} disabled={submitting} className="prim-btn">
                {submitting?<><Spinner/>Envoi…</>:<>Envoyer la demande</>}
              </button>
            </div>
          }>
          <div style={{background:"rgba(251,191,36,0.08)",border:"0.5px solid rgba(251,191,36,0.2)",borderRadius:9,padding:"12px 14px",marginBottom:18}}>
            <div style={{fontSize:10.5,color:"#fbbf24",fontWeight:600,textTransform:"uppercase",letterSpacing:0.5,marginBottom:4}}>Solde disponible</div>
            <div style={{fontFamily:"'DM Mono',monospace",fontSize:20,fontWeight:700,color:"#fbbf24"}}>{revenueRestant.toLocaleString()} MGA</div>
          </div>
          <Field label="Montant demandé (MGA) *">
            <input style={inp} type="number" placeholder={`Max : ${revenueRestant.toLocaleString()} MGA`} value={form.amount} onChange={e=>setForm({...form,amount:e.target.value})}/>
          </Field>
          <Field label="Opérateur mobile *">
            <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
              {OPERATEURS.map(op=>(
                <button key={op} onClick={()=>setForm({...form,nomOperateur:op})} style={{ fontSize:12,padding:"6px 14px",borderRadius:20,border:"0.5px solid",background:form.nomOperateur===op?"#4ade80":"transparent",color:form.nomOperateur===op?"#0f1117":"#8b8fa8",borderColor:form.nomOperateur===op?"#4ade80":"#2a2d38",cursor:"pointer",fontFamily:"inherit",fontWeight:form.nomOperateur===op?700:400 }}>{op}</button>
              ))}
            </div>
          </Field>
          <Field label="Nom inscrit sur la carte SIM *">
            <input style={inp} type="text" placeholder="Ex : RAKOTO JEAN" value={form.nomCarteSim} onChange={e=>setForm({...form,nomCarteSim:e.target.value.toUpperCase()})}/>
            <div style={{fontSize:11,color:"#8b8fa8",marginTop:5,display:"flex",alignItems:"center",gap:5}}><InfoIcon/> Ce nom doit correspondre exactement à votre compte Mobile Money</div>
          </Field>
          <Field label="Numéro de réception *">
            <input style={inp} type="tel" placeholder="Ex : 034 12 345 67" value={form.numeroOperateur} onChange={e=>setForm({...form,numeroOperateur:e.target.value})}/>
          </Field>
          {form.nomOperateur&&form.nomCarteSim&&form.numeroOperateur&&(
            <div style={{background:"rgba(74,222,128,0.08)",border:"0.5px solid rgba(74,222,128,0.2)",borderRadius:9,padding:"9px 14px",marginBottom:14,fontSize:12,color:"#4ade80",display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
              <CheckIcon/> Paiement via <strong>{form.nomOperateur}</strong> · {form.nomCarteSim} · {form.numeroOperateur}
            </div>
          )}
          <Field label="Motif / Note (optionnel)">
            <textarea style={{...inp,height:72,resize:"vertical",lineHeight:1.6}} placeholder="Ex : Remboursement carburant…" value={form.motif} onChange={e=>setForm({...form,motif:e.target.value})}/>
          </Field>
        </Modal>
      )}
      <Toast toast={toast}/>
    </div>
  );
};

/* ═══════════════════════════════════════════
   CARPOOLING PAGE
═══════════════════════════════════════════ */
const CarpoolingPage = ({ cities, onRefresh }) => {
  const [stops,      setStops]      = useState([{cityId:"",time:""},{cityId:"",time:""}]);
  const [data,       setData]       = useState({price:"",seats:"",departureDate:"",description:""});
  const [carpools,   setCarpools]   = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [toast,      setToast]      = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting,     setDeleting]     = useState(false);

  const [createdCarpoolId,       setCreatedCarpoolId]       = useState(null);
  const [carpoolPhotos,          setCarpoolPhotos]          = useState([]);
  const [carpoolPhotosUploading, setCarpoolPhotosUploading] = useState(false);

  const showToast=(type,msg)=>{setToast({type,msg});setTimeout(()=>setToast(null),3500);};
  const load=useCallback(async()=>{ setLoading(true); try{ const r=await api.get("/transporter/carpooling"); setCarpools((r.data||[]).sort((a,b)=>new Date(b.createdAt||b.departureDate||0)-new Date(a.createdAt||a.departureDate||0))); }catch{} setLoading(false); },[]);
  useEffect(()=>{load();},[load]);

  const addStop    = ()       => setStops([...stops,{cityId:"",time:""}]);
  const removeStop = i        => setStops(stops.filter((_,idx)=>idx!==i));
  const updateStop = (i,f,v) => { const u=[...stops]; u[i][f]=v; setStops(u); };

  const handleSubmit=async()=>{
    if(stops.some(st=>!st.cityId))         return showToast("error","Sélectionnez une ville pour chaque étape.");
    if(!data.departureDate)                return showToast("error","Date de départ requise.");
    if(!data.price||data.price<=0)         return showToast("error","Prix invalide.");
    if(!data.seats||data.seats<=0)         return showToast("error","Nombre de places invalide.");
    const ids=stops.map(st=>st.cityId);
    if(new Set(ids).size!==ids.length)     return showToast("error","Deux étapes ne peuvent pas avoir la même ville.");
    setSubmitting(true);
    try{
      const r=await api.post("/transporter/carpooling",{ itinerary:stops.map(st=>({cityId:st.cityId,time:st.time})), price:Number(data.price), seats:Number(data.seats), departureDate:data.departureDate, description:data.description });
      setCarpools(prev=>[r.data,...prev]);
      setCreatedCarpoolId(r.data.id);
      setCarpoolPhotos([]);
      showToast("success","Covoiturage publié ! Ajoutez des photos du véhicule.");
      onRefresh();
    }catch{ showToast("error","Erreur lors de la création."); }
    setSubmitting(false);
  };

  const handleCarpoolPhotoUpload = async (files) => {
    if (!createdCarpoolId) return;
    setCarpoolPhotosUploading(true);
    for (const file of files) {
      try {
        const fd = new FormData();
        fd.append("photo", file);
        const r = await api.post(`/transporter/carpooling/${createdCarpoolId}/photos`, fd, { headers: { "Content-Type": "multipart/form-data" } });
        setCarpoolPhotos(prev => [...prev, r.data.photoUrl]);
        setCarpools(prev => prev.map(c => c.id === createdCarpoolId ? { ...c, photos: [...(c.photos ?? []), r.data.photoUrl] } : c));
      } catch { showToast("error", `Erreur upload : ${file.name}`); }
    }
    setCarpoolPhotosUploading(false);
  };

  const handleCarpoolPhotoRemove = (idx) => {
    setCarpoolPhotos(prev => prev.filter((_, i) => i !== idx));
  };

  const finishCarpoolCreation = () => {
    setCreatedCarpoolId(null);
    setCarpoolPhotos([]);
    setStops([{cityId:"",time:""},{cityId:"",time:""}]);
    setData({price:"",seats:"",departureDate:"",description:""});
  };

  // Delete carpool
  const confirmDeleteCarpool = async () => {
    if (!deleteTarget) return;
    setDeleting(true);
    try {
      await api.delete(`/transporter/carpooling/${deleteTarget.id}`);
      setCarpools(prev => prev.filter(c => c.id !== deleteTarget.id));
      showToast("success", "Covoiturage supprimé.");
      setDeleteTarget(null);
    } catch {
      showToast("error", "Erreur lors de la suppression.");
    }
    setDeleting(false);
  };

  const cityName=id=>cities.find(c=>String(c.id)===String(id))?.name??id;

  return (
    <div>
      <div style={s.pageHeader}><div><h1 style={s.pageTitle}>Covoiturage</h1><p style={s.pageSub}>Proposez un trajet partagé étape par étape</p></div></div>

      {createdCarpoolId ? (
        <div style={{ ...s.card, maxWidth:600, marginBottom:20 }}>
          <div style={{ background:"rgba(74,222,128,0.07)", border:"0.5px solid rgba(74,222,128,0.2)", borderRadius:9, padding:"10px 14px", marginBottom:16, fontSize:13, color:"#4ade80", display:"flex", alignItems:"center", gap:8 }}>
            <CheckIcon /> Covoiturage publié avec succès !
          </div>
          <div style={{ background:"rgba(96,165,250,0.07)", border:"0.5px solid rgba(96,165,250,0.2)", borderRadius:9, padding:"10px 14px", marginBottom:20, fontSize:12, color:"#60a5fa", display:"flex", alignItems:"flex-start", gap:8 }}>
            <InfoIcon />
            <span>Ajoutez une photo <strong>extérieure</strong> puis une photo <strong>intérieure</strong> de votre véhicule pour rassurer les passagers.</span>
          </div>
          <PhotoUploader
            photos={carpoolPhotos}
            onAdd={handleCarpoolPhotoUpload}
            onRemove={handleCarpoolPhotoRemove}
            uploading={carpoolPhotosUploading}
            label="Ajouter des photos du véhicule (ext. + int.)"
          />
          <div style={{ display:"flex", justifyContent:"flex-end", marginTop:20, paddingTop:16, borderTop:"0.5px solid #2a2d38" }}>
            <button style={s.primaryBtn} onClick={finishCarpoolCreation} className="prim-btn"><CheckIcon /> Terminer</button>
          </div>
        </div>
      ) : (
        <div className="coop-grid" style={{marginBottom:20}}>
          <div style={s.card}>
            <h2 style={{...s.cardTitle,marginBottom:20}}>Itinéraire</h2>
            <div style={{position:"relative"}}>
              <div style={{position:"absolute",left:18,top:20,bottom:20,width:2,background:"linear-gradient(to bottom,#4ade80,#1e2029)",borderRadius:2}}/>
              {stops.map((stop,i)=>{
                const isFirst=i===0,isLast=i===stops.length-1;
                return (
                  <div key={i} style={{display:"flex",gap:14,alignItems:"flex-start",marginBottom:14}}>
                    <div style={{width:36,height:36,borderRadius:"50%",flexShrink:0,zIndex:1,position:"relative",background:isFirst?"#4ade80":"#1e2029",border:`2px solid ${isFirst?"#4ade80":isLast?"#4ade80":"#2a2d38"}`,display:"flex",alignItems:"center",justifyContent:"center",color:isFirst?"#0f1117":"#4ade80",fontWeight:700,fontSize:12}}>
                      {isFirst?"A":isLast?"B":i}
                    </div>
                    <div style={{flex:1,display:"grid",gridTemplateColumns:"1fr auto auto",gap:8,alignItems:"center",minWidth:0}}>
                      <select style={{...sel,minWidth:0}} value={stop.cityId} onChange={e=>updateStop(i,"cityId",e.target.value)}>
                        <option value="">{isFirst?"Ville de départ":isLast?"Ville d'arrivée":`Étape ${i}`}</option>
                        {cities.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
                      </select>
                      <input type="time" style={{...inp,width:100}} value={stop.time} onChange={e=>updateStop(i,"time",e.target.value)}/>
                      {!isFirst&&!isLast&&<button onClick={()=>removeStop(i)} style={{background:"none",border:"none",color:"#f87171",cursor:"pointer",padding:"4px 6px"}}><TrashIcon/></button>}
                    </div>
                  </div>
                );
              })}
            </div>
            <button style={s.ghostBtn} onClick={addStop}><PlusIcon/> Ajouter une étape intermédiaire</button>
          </div>
          <div style={s.card}>
            <h2 style={{...s.cardTitle,marginBottom:18}}>Détails du trajet</h2>
            <Field label="Date de départ *"><input type="date" style={inp} value={data.departureDate} onChange={e=>setData({...data,departureDate:e.target.value})}/></Field>
            <Field label="Prix par personne (MGA) *"><input type="number" style={inp} placeholder="Ex : 5 000" value={data.price} onChange={e=>setData({...data,price:e.target.value})}/></Field>
            <Field label="Places disponibles *"><input type="number" style={inp} placeholder="Ex : 3" value={data.seats} onChange={e=>setData({...data,seats:e.target.value})}/></Field>
            <Field label="Description (optionnel)"><textarea style={{...inp,height:72,resize:"vertical"}} placeholder="Climatisation, animaux…" value={data.description} onChange={e=>setData({...data,description:e.target.value})}/></Field>
            <div style={{ display:"flex", alignItems:"center", gap:7, background:"rgba(74,222,128,0.06)", border:"0.5px solid rgba(74,222,128,0.2)", borderRadius:9, padding:"9px 14px", marginBottom:14, fontSize:12, color:"#4ade80" }}>
              <ShieldIcon/> Annulation gratuite pour les passagers jusqu'à 12h avant le départ
            </div>
            <CommissionBanner type="trip" />
            <button style={{...s.primaryBtn,width:"100%",marginTop:4,justifyContent:"center"}} onClick={handleSubmit} disabled={submitting} className="prim-btn">
              {submitting?<><Spinner/>Publication…</>:<><CarIcon/> Publier le covoiturage</>}
            </button>
          </div>
        </div>
      )}

      <div style={s.card}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16,flexWrap:"wrap",gap:8}}>
          <h2 style={s.cardTitle}>Mes covoiturages</h2>
          <Badge variant="info">{carpools.length} actifs</Badge>
        </div>
        {loading?<div style={{textAlign:"center",padding:"24px 0",color:"#8b8fa8"}}>Chargement…</div>
          :carpools.length===0?<div style={{textAlign:"center",padding:"24px 0",color:"#8b8fa8"}}>Aucun covoiturage publié pour l'instant</div>
          :(
            <div className="cards-grid">
              {carpools.map((c,i)=>(
                <div key={c.id??i} style={{ ...s.tripCard, position:"relative" }} className="trip-card">
                  {/* Delete button */}
                  <button
                    onClick={() => setDeleteTarget(c)}
                    style={{ position:"absolute", top:10, right:10, width:26, height:26, borderRadius:"50%", background:"rgba(248,113,113,0.1)", border:"0.5px solid rgba(248,113,113,0.25)", color:"#f87171", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", zIndex:2 }}
                    title="Supprimer ce covoiturage"
                  >
                    <TrashIcon />
                  </button>

                  {c.photos?.[0] && (
                    <div style={{ height:90, borderRadius:8, overflow:"hidden", marginBottom:10, position:"relative" }}>
                      <img src={getPhotoUrl(c.photos[0])} alt="" style={{ width:"100%", height:"100%", objectFit:"cover" }} />
                      {c.photos.length > 1 && (
                        <span style={{ position:"absolute", bottom:5, right:5, fontSize:9, fontWeight:700, background:"rgba(0,0,0,0.7)", color:"#c8cad8", padding:"2px 6px", borderRadius:8 }}>+{c.photos.length-1} photo{c.photos.length>2?"s":""}</span>
                      )}
                    </div>
                  )}
                  <div style={{display:"flex",alignItems:"center",gap:5,marginBottom:10,fontSize:13,fontWeight:600,color:"#e8e9ed",flexWrap:"wrap",paddingRight:32}}>
                    <span>{c.departure??c.itinerary?.[0]?.city??"—"}</span>
                    <span style={{color:"#4a4d5a"}}><ArrowIcon/></span>
                    <span>{c.arrival??c.itinerary?.[c.itinerary?.length-1]?.city??"—"}</span>
                  </div>
                  {Array.isArray(c.itinerary)&&c.itinerary.length>2&&(
                    <div style={{fontSize:11,color:"#8b8fa8",marginBottom:8}}>{c.itinerary.slice(1,-1).map(st=>st.city??cityName(st.cityId)).join(" → ")}</div>
                  )}
                  <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                    <Badge variant="success">{Number(c.price).toLocaleString()} MGA</Badge>
                    <Badge variant="neutral">{c.seats} places</Badge>
                    {c.departureDate&&<Badge variant="info">{new Date(c.departureDate).toLocaleDateString("fr-FR")}</Badge>}
                  </div>
                  {c.description&&<div style={{fontSize:11,color:"#8b8fa8",marginTop:8}}>{c.description}</div>}
                  <div style={{display:"flex",alignItems:"center",gap:4,fontSize:10.5,color:"#4ade80",marginTop:8}}><ShieldIcon/> Annulation 12h avant</div>
                </div>
              ))}
            </div>
          )}
      </div>

      {deleteTarget && (
        <ConfirmDeleteModal
          title="Supprimer ce covoiturage ?"
          message={`Le covoiturage "${deleteTarget.departure ?? "—"} → ${deleteTarget.arrival ?? "—"}" sera définitivement supprimé.`}
          onConfirm={confirmDeleteCarpool}
          onCancel={() => setDeleteTarget(null)}
          loading={deleting}
        />
      )}
      <Toast toast={toast}/>
    </div>
  );
};

/* ═══════════════════════════════════════════
   MAIN DASHBOARD
═══════════════════════════════════════════ */
const TransporterDashboard = () => {
  const {logout,user}               = useAuth();
  const [activePage,  setActivePage] = useState(PAGES.DASHBOARD);
  const [stats,       setStats]      = useState({trips:0,bookings:0,revenueTotal:0,revenuePaye:0});
  const [trips,       setTrips]      = useState([]);
  const [cities,      setCities]     = useState([]);
  const [showModal,   setShowModal]  = useState(false);
  const [creating,    setCreating]   = useState(false);
  const [showSidebar, setSidebar]    = useState(false);

  // Delete state for trips & bookings (managed at root level since trips state lives here)
  const [deleteTarget, setDeleteTarget] = useState(null); // { type: "trip"|"booking", item, bookingTripId? }
  const [deleting,     setDeleting]     = useState(false);
  const [deleteToast,  setDeleteToast]  = useState(null);

  const [tripForm, setTripForm] = useState({
    departure:"", arrival:"", price:"", seats:"", departureTime:"",
    tripType:"Taxi-brousse", stationName:"", stationAddress:"",
  });

  const [takenSeats,] = useState([]);
  const [pickedSeat, setPickedSeat] = useState(null);

  const [createdTripId,       setCreatedTripId]       = useState(null);
  const [tripPhotosList,      setTripPhotosList]      = useState([]);
  const [tripPhotosUploading, setTripPhotosUploading] = useState(false);

  const loadStats  = useCallback(async()=>{ try{const r=await api.get("/transporter/stats"); setStats(r.data);}catch{} },[]);
  const loadTrips  = useCallback(async()=>{ try{
    const r=await api.get("/transporter/trips");
    // Tri du plus récent au plus ancien
    setTrips((r.data||[]).sort((a,b)=>new Date(b.departureTime||b.createdAt||0)-new Date(a.departureTime||a.createdAt||0)));
  }catch{} },[]);
  const loadCities = useCallback(async()=>{ try{const r=await api.get("/cities"); setCities(r.data);}catch{} },[]);
  const refreshAll = useCallback(()=>{ loadStats(); loadTrips(); },[loadStats,loadTrips]);

  useEffect(()=>{ if(!user?.isValidated)return; loadStats();loadTrips();loadCities(); },[user,loadStats,loadTrips,loadCities]);

  useEffect(() => {
    document.body.style.overflow = showSidebar ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [showSidebar]);

  const showDelToast = (type, msg) => { setDeleteToast({type,msg}); setTimeout(()=>setDeleteToast(null),3500); };

  // ── Delete trip ──
  const handleDeleteTrip = (trip) => { setDeleteTarget({ type:"trip", item:trip }); };

  // ── Delete booking (from BookingsPage) ──
  const handleDeleteBooking = (booking) => { setDeleteTarget({ type:"booking", item:booking }); };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    setDeleting(true);
    try {
      if (deleteTarget.type === "trip") {
        await api.delete(`/transporter/trips/${deleteTarget.item.id}`);
        setTrips(prev => prev.filter(t => t.id !== deleteTarget.item.id));
        showDelToast("success", "Trajet supprimé.");
        refreshAll();
      } else if (deleteTarget.type === "booking") {
        await api.delete(`/transporter/bookings/${deleteTarget.item.id}`);
        // Remove booking from nested trips state
        setTrips(prev => prev.map(t => ({
          ...t,
          bookings: (t.bookings||[]).filter(b => b.id !== deleteTarget.item.id)
        })));
        showDelToast("success", "Réservation supprimée.");
      }
      setDeleteTarget(null);
    } catch {
      showDelToast("error", "Erreur lors de la suppression.");
    }
    setDeleting(false);
  };

  const createTrip=async()=>{
    const {departure,arrival,price,seats,departureTime}=tripForm;
    if(!departure||!arrival||!price||!seats||!departureTime) return alert("Veuillez remplir tous les champs.");
    if(departure===arrival) return alert("Départ et arrivée doivent être différents.");
    setCreating(true);
    try{
      const r = await api.post("/transporter/trips",{...tripForm,seats:Number(seats),price:Number(price)});
      setCreatedTripId(r.data.id);
      setTripPhotosList([]);
      refreshAll();
    }catch{alert("Erreur lors de la création.");}
    setCreating(false);
  };

  const handleTripPhotoUpload = async (files) => {
    if (!createdTripId) return;
    setTripPhotosUploading(true);
    for (const file of files) {
      try {
        const fd = new FormData();
        fd.append("photo", file);
        const r = await api.post(`/transporter/trips/${createdTripId}/photos`, fd, { headers: { "Content-Type": "multipart/form-data" } });
        setTripPhotosList(prev => [...prev, r.data.photoUrl]);
      } catch {}
    }
    setTripPhotosUploading(false);
  };

  const handleTripPhotoRemove = (idx) => {
    setTripPhotosList(prev => prev.filter((_, i) => i !== idx));
  };

  const closeModal = () => {
    setShowModal(false);
    setCreatedTripId(null);
    setTripPhotosList([]);
    setTripPhotosUploading(false);
    setTripForm({departure:"",arrival:"",price:"",seats:"",departureTime:"",tripType:"Taxi-brousse",stationName:"",stationAddress:""});
    setPickedSeat(null);
  };

  if(!user) return null;

  if(!user.isValidated) return (
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"100vh",background:"#0f1117",fontFamily:"'Plus Jakarta Sans',sans-serif",padding:16}}>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      <div style={{background:"#16181f",border:"0.5px solid #2a2d38",borderRadius:16,padding:"48px 32px",textAlign:"center",width:"100%",maxWidth:420}}>
        <div style={{fontSize:40,marginBottom:16}}>⏳</div>
        <h2 style={{fontSize:20,fontWeight:700,color:"#fbbf24",marginBottom:10}}>Compte en attente de validation</h2>
        <p style={{fontSize:14,color:"#8b8fa8",lineHeight:1.7,marginBottom:24}}>Félicitations ! Votre compte est en cours de vérification par notre équipe. Nous vous contacterons dès que possible.</p>
        <button style={{...s.ghostBtn,width:"100%",justifyContent:"center"}} onClick={logout}><LogoutIcon/> Déconnexion</button>
      </div>
    </div>
  );

  const NAV=[
    {key:PAGES.DASHBOARD, icon:<HomeIcon/>, label:"Accueil"},
    {key:PAGES.TRIPS,     icon:<BusIcon/>,  label:"Trajets"},
    {key:PAGES.BOOKINGS,  icon:<UsersIcon/>,label:"Réservations"},
    {key:PAGES.REVENUE,   icon:<MoneyIcon/>,label:"Revenus"},
    {key:PAGES.CARPOOLING,icon:<CarIcon/>,  label:"Covoit."},
    {key:PAGES.RENTAL,    icon:<KeyIcon/>,  label:"Location"},
  ];

  const revenueTotal   = Number(stats.revenueTotal??stats.revenue??0);
  const revenuePaye    = Number(stats.revenuePaye??0);
  const revenueRestant = Math.max(0,revenueTotal-revenuePaye);

  const selectedTypeCfg = TRIP_TYPES.find(t=>t.id===tripForm.tripType) || TRIP_TYPES[0];

  const navigate = (key) => { setActivePage(key); setSidebar(false); };

  const renderPage=()=>{
    switch(activePage){
      case PAGES.TRIPS:      return <TripsPage trips={trips} onAdd={()=>setShowModal(true)} onDeleteTrip={handleDeleteTrip}/>;
      case PAGES.BOOKINGS:   return <BookingsPage trips={trips} onDeleteBooking={handleDeleteBooking}/>;
      case PAGES.REVENUE:    return <RevenuePage stats={stats} onRefresh={refreshAll}/>;
      case PAGES.CARPOOLING: return <CarpoolingPage cities={cities} onRefresh={refreshAll}/>;
      case PAGES.RENTAL:     return <RentalPage onRefresh={refreshAll} cities={cities}/>;
      default: return (
        <div>
          <div style={s.pageHeader}>
            <div><h1 style={s.pageTitle}>Bonjour{user?.name?`, ${user.name.split(" ")[0]}`:""} 👋</h1><p style={s.pageSub}>Voici un aperçu de votre activité</p></div>
            <button style={s.primaryBtn} onClick={()=>setShowModal(true)} className="prim-btn"><PlusIcon/> Ajouter un trajet</button>
          </div>

          <div className="stats-grid" style={{marginBottom:20}}>
            {[
              {key:PAGES.TRIPS,     label:"Trajets",          value:stats.trips??0,                          color:"#4ade80",bg:"rgba(74,222,128,0.1)",  icon:<BusIcon/>},
              {key:PAGES.BOOKINGS,  label:"Réservations",     value:stats.bookings??0,                       color:"#60a5fa",bg:"rgba(96,165,250,0.1)",  icon:<UsersIcon/>},
              {key:PAGES.REVENUE,   label:"Solde disponible", value:`${revenueRestant.toLocaleString()} MGA`,color:"#fbbf24",bg:"rgba(251,191,36,0.1)",  icon:<WalletIcon/>},
              {key:PAGES.CARPOOLING,label:"Covoiturage",      value:"Nouveau",                               color:"#a78bfa",bg:"rgba(167,139,250,0.1)", icon:<CarIcon/>},
              {key:PAGES.RENTAL,    label:"Location",         value:stats.rentalCars??0,                     color:"#34d399",bg:"rgba(52,211,153,0.1)",  icon:<KeyIcon/>},
            ].map(({key,label,value,color,bg,icon})=>(
              <div key={key} style={{...s.statCard,cursor:"pointer"}} onClick={()=>navigate(key)} className="stat-card">
                <div style={{...s.statIcon,background:bg,color}}>{icon}</div>
                <div style={s.statValue}>{value}</div>
                <div style={s.statLabel}>{label}</div>
                <div style={{display:"flex",alignItems:"center",gap:4,marginTop:8,fontSize:11,color}}>Voir <ChevronIcon/></div>
              </div>
            ))}
          </div>

          <div style={{...s.card,background:"linear-gradient(135deg,#16181f,#1a1d27)",marginBottom:18}}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16,flexWrap:"wrap",gap:8}}>
              <h2 style={s.cardTitle}>Aperçu des revenus</h2>
              <button style={{...s.ghostBtn,fontSize:12,padding:"5px 12px"}} onClick={()=>navigate(PAGES.REVENUE)}>Voir le détail →</button>
            </div>
            <div className="rv-mini-grid">
              {[
                {label:"Total généré (93 %)",value:revenueTotal,  color:"#e8e9ed",hint:"des billets confirmés"},
                {label:"Déjà perçu",          value:revenuePaye,  color:"#4ade80",hint:"paiements approuvés"},
                {label:"Solde disponible",    value:revenueRestant,color:"#fbbf24",hint:"à percevoir"},
              ].map(({label,value,color,hint})=>(
                <div key={label} style={{paddingBottom:12}}>
                  <div style={{fontSize:10.5,color:"#8b8fa8",textTransform:"uppercase",letterSpacing:0.5,fontWeight:600,marginBottom:5}}>{label}</div>
                  <div style={{fontFamily:"'DM Mono',monospace",fontSize:17,fontWeight:700,color,letterSpacing:-0.5}}>{value.toLocaleString()} <span style={{fontSize:10,opacity:0.5}}>MGA</span></div>
                  <div style={{fontSize:10.5,color:"#4a4d5a",marginTop:3}}>{hint}</div>
                </div>
              ))}
            </div>
          </div>

          <div style={s.card}>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16,flexWrap:"wrap",gap:8}}>
              <h2 style={s.cardTitle}>Trajets récents</h2>
              <button style={{...s.ghostBtn,fontSize:12,padding:"5px 12px"}} onClick={()=>navigate(PAGES.TRIPS)}>Voir tout →</button>
            </div>
            {trips.length===0?(
              <div style={s.emptyState}>
                <div style={{fontSize:28,marginBottom:8}}>🚌</div>
                <div style={{fontSize:13,color:"#8b8fa8",marginBottom:10}}>Aucun trajet</div>
                <button style={s.primaryBtn} onClick={()=>setShowModal(true)} className="prim-btn"><PlusIcon/> Créer un trajet</button>
              </div>
            ):(
              <div style={{overflowX:"auto",WebkitOverflowScrolling:"touch"}}>
                <table style={s.table}>
                  <thead><tr>{["Type","Départ","Arrivée","Gare","Date / Heure","Places","Prix"].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
                  <tbody>
                    {trips.slice(0,5).map(t=>(
                      <tr key={t.id} className="brow">
                        <td style={s.td}>{t.tripType?<Badge variant="neutral">{t.tripType}</Badge>:"—"}</td>
                        <td style={s.td}><span style={s.cityTag}>{t.departure}</span></td>
                        <td style={s.td}><span style={s.cityTag}>{t.arrival}</span></td>
                        <td style={{...s.td,fontSize:11,color:"#60a5fa",whiteSpace:"nowrap"}}>{t.stationName||"—"}</td>
                        <td style={{...s.td,color:"#8b8fa8",fontSize:12,fontFamily:"'DM Mono',monospace",whiteSpace:"nowrap"}}>{t.departureTime}</td>
                        <td style={s.td}><Badge variant="neutral">{t.seats}</Badge></td>
                        <td style={{...s.td,whiteSpace:"nowrap"}}><span style={{fontFamily:"'DM Mono',monospace",color:"#4ade80",fontWeight:600}}>{Number(t.price).toLocaleString()} MGA</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      );
    }
  };

  const BottomNav = () => (
    <nav className="bottom-nav">
      {NAV.map(({key,icon,label}) => (
        <button key={key} onClick={() => navigate(key)} className={`bottom-nav-item${activePage===key?" active":""}`}>
          <span className="bottom-nav-icon">{icon}</span>
          <span className="bottom-nav-label">{label}</span>
        </button>
      ))}
      <button onClick={logout} className="bottom-nav-item" style={{ color:"#f87171" }}>
        <span className="bottom-nav-icon"><LogoutIcon /></span>
        <span className="bottom-nav-label">Quitter</span>
      </button>
    </nav>
  );

  return (
    <div style={s.layout}>
      <style>{globalCSS}</style>

      {showSidebar && <div style={s.overlay} onClick={()=>setSidebar(false)}/>}

      <div className={`tp-sidebar${showSidebar?" sidebar-open":""}`}>
        <div style={s.sidebarInner}>
          <div style={s.sidebarLogoWrap}>
            <div style={s.sidebarLogo}>Trans<span style={{color:"#4ade80"}}>TiGo</span></div>
            <span style={s.adminPill}>Transporteur</span>
          </div>
          <div style={s.userCard}>
            <Avatar name={user?.name} color="#4ade80"/>
            <div style={{minWidth:0}}>
              <div style={{fontSize:13,fontWeight:600,color:"#e8e9ed",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{user?.name||"Transporteur"}</div>
              <div style={{fontSize:11,color:"#4ade80"}}>● Compte actif</div>
            </div>
          </div>
          <nav style={s.nav}>
            {NAV.map(({key,icon,label})=>(
              <button key={key} onClick={()=>navigate(key)} style={{...s.navItem,...(activePage===key?s.navItemActive:{})}} className="nav-item-btn">
                <span style={{...s.navIcon,color:activePage===key?"#4ade80":"#8b8fa8"}}>{icon}</span>
                {label}
                {activePage===key&&<div style={s.navActiveBar}/>}
              </button>
            ))}
          </nav>
          <div style={s.miniStats}>
            {[["Total",`${revenueTotal.toLocaleString()}`,"#e8e9ed"],["Perçu",`${revenuePaye.toLocaleString()}`,"#4ade80"],["Solde",`${revenueRestant.toLocaleString()}`,"#fbbf24"]].map(([l,v,c])=>(
              <div key={l} style={{textAlign:"center",minWidth:0}}>
                <div style={{fontSize:11,fontWeight:700,color:c,fontFamily:"'DM Mono',monospace",overflow:"hidden",textOverflow:"ellipsis"}}>{v}</div>
                <div style={{fontSize:9,color:"#8b8fa8",marginTop:1}}>{l}</div>
              </div>
            ))}
          </div>
          <div style={{padding:"0 12px",marginTop:"auto"}}>
            <button style={s.logoutBtn} onClick={logout} className="logout-btn"><LogoutIcon/> Déconnexion</button>
          </div>
        </div>
      </div>

      <div style={s.main} className="tp-main">{renderPage()}</div>

      <BottomNav />

      {/* Global delete confirm modal (trips & bookings) */}
      {deleteTarget && (
        <ConfirmDeleteModal
          title={deleteTarget.type === "trip" ? "Supprimer ce trajet ?" : "Supprimer cette réservation ?"}
          message={
            deleteTarget.type === "trip"
              ? `Le trajet "${deleteTarget.item.departure} → ${deleteTarget.item.arrival}" et toutes ses réservations associées seront définitivement supprimés.`
              : `La réservation de "${deleteTarget.item.fullName || "ce passager"}" sera définitivement supprimée.`
          }
          onConfirm={confirmDelete}
          onCancel={() => setDeleteTarget(null)}
          loading={deleting}
        />
      )}
      <Toast toast={deleteToast} />

      {/* TRIP MODAL — two-step */}
      {showModal && (
        <Modal
          title={createdTripId ? "📷 Photos du véhicule" : "Créer un trajet"}
          subtitle={createdTripId
            ? "Trajet créé ! Ajoutez une photo extérieure + intérieure (optionnel)."
            : "Remplissez les informations du trajet"}
          onClose={closeModal}
          wide
        >
          {!createdTripId ? (
            <>
              <div style={{ marginBottom: 16 }}>
                <div style={{ fontSize:11, fontWeight:600, color:"#8b8fa8", textTransform:"uppercase", letterSpacing:0.5, marginBottom:8 }}>Type de trajet *</div>
                <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                  {TRIP_TYPES.map(t => (
                    <button key={t.id} onClick={() => { setTripForm(f => ({ ...f, tripType:t.id, seats:t.seats, departure:"", arrival:"" })); setPickedSeat(null); }} style={{
                      flex:1, minWidth:110, padding:"12px 8px", borderRadius:10,
                      border:`1.5px solid ${tripForm.tripType===t.id?"#4ade80":"#2a2d38"}`,
                      background: tripForm.tripType===t.id?"rgba(74,222,128,0.1)":"transparent",
                      color: tripForm.tripType===t.id?"#4ade80":"#8b8fa8",
                      cursor:"pointer", fontFamily:"inherit", fontWeight:700, fontSize:13
                    }}>
                      {t.id==="Taxi-brousse"?"🚐":"🚗"} {t.label}
                      <div style={{ fontSize:10, opacity:0.6, marginTop:3 }}>{t.seats} places max</div>
                    </button>
                  ))}
                </div>
              </div>

              <div className="form-grid-2">
                <Field label="Ville de départ *">
                  {tripForm.tripType === "Taxi-brousse" ? (
                    <select style={sel} value={tripForm.departure} onChange={e=>setTripForm({...tripForm,departure:e.target.value})}>
                      <option value="">Sélectionner…</option>
                      {cities.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
                    </select>
                  ) : (
                    <>
                      <input type="text" style={inp} placeholder="Ex : Mahajanga…" value={tripForm.departure} onChange={e=>setTripForm({...tripForm,departure:e.target.value})}/>
                      <div style={{ fontSize:10.5, color:"#60a5fa", marginTop:5, display:"flex", alignItems:"center", gap:5 }}><InfoIcon/> Saisissez manuellement</div>
                    </>
                  )}
                </Field>
                <Field label="Ville d'arrivée *">
                  {tripForm.tripType === "Taxi-brousse" ? (
                    <select style={sel} value={tripForm.arrival} onChange={e=>setTripForm({...tripForm,arrival:e.target.value})}>
                      <option value="">Sélectionner…</option>
                      {cities.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
                    </select>
                  ) : (
                    <>
                      <input type="text" style={inp} placeholder="Ex : Antananarivo…" value={tripForm.arrival} onChange={e=>setTripForm({...tripForm,arrival:e.target.value})}/>
                      <div style={{ fontSize:10.5, color:"#60a5fa", marginTop:5, display:"flex", alignItems:"center", gap:5 }}><InfoIcon/> Saisissez manuellement</div>
                    </>
                  )}
                </Field>
              </div>

              <Field label="Date et heure de départ *">
                <input type="datetime-local" style={inp} value={tripForm.departureTime} onChange={e=>setTripForm({...tripForm,departureTime:e.target.value})}/>
              </Field>

              <div className="form-grid-2">
                <Field label="Prix (MGA) *">
                  <input type="number" style={inp} placeholder="Ex : 8 000" value={tripForm.price} onChange={e=>setTripForm({...tripForm,price:e.target.value})}/>
                </Field>
                <Field label="Nombre de places *">
                  <input type="number" style={inp} placeholder={`${selectedTypeCfg.seats}`} value={tripForm.seats} onChange={e=>setTripForm({...tripForm,seats:e.target.value})}/>
                </Field>
              </div>

              {tripForm.tripType === "Covoiturage" && (
                <div style={{ display:"flex", alignItems:"center", gap:7, background:"rgba(74,222,128,0.06)", border:"0.5px solid rgba(74,222,128,0.2)", borderRadius:9, padding:"9px 14px", marginBottom:14, fontSize:12, color:"#4ade80" }}>
                  <ShieldIcon/> Annulation gratuite pour les passagers jusqu'à 12h avant le départ
                </div>
              )}

              {Number(tripForm.seats || selectedTypeCfg.seats || 0) > 0 && (
                <div style={{ marginBottom:4 }}>
                  <div style={{ fontSize:11, fontWeight:600, color:"#8b8fa8", textTransform:"uppercase", letterSpacing:0.5, marginBottom:8 }}>Aperçu des places</div>
                  <VisualSeatPicker totalSeats={Number(tripForm.seats||selectedTypeCfg.seats)} takenSeats={takenSeats} selected={pickedSeat} onSelect={setPickedSeat}/>
                </div>
              )}
              <CommissionBanner type="trip" />
              <div style={{ display:"flex", justifyContent:"flex-end", gap:8, marginTop:20, paddingTop:16, borderTop:"0.5px solid #2a2d38", flexWrap:"wrap" }}>
                <button style={s.ghostBtn} onClick={closeModal}>Annuler</button>
                <button style={{...s.primaryBtn,opacity:creating?0.7:1}} onClick={createTrip} disabled={creating} className="prim-btn">
                  {creating?<><Spinner/>Création…</>:<><PlusIcon/>Créer le trajet</>}
                </button>
              </div>
            </>
          ) : (
            <>
              <div style={{ background:"rgba(74,222,128,0.07)", border:"0.5px solid rgba(74,222,128,0.2)", borderRadius:9, padding:"10px 14px", marginBottom:16, fontSize:13, color:"#4ade80", display:"flex", alignItems:"center", gap:8 }}>
                <CheckIcon /> Trajet créé avec succès !
              </div>
              <div style={{ background:"rgba(96,165,250,0.07)", border:"0.5px solid rgba(96,165,250,0.2)", borderRadius:9, padding:"10px 14px", marginBottom:20, fontSize:12, color:"#60a5fa", display:"flex", alignItems:"flex-start", gap:8 }}>
                <InfoIcon />
                <span>Ajoutez une photo <strong>extérieure</strong> (couverture) puis une photo <strong>intérieure</strong> de votre véhicule.</span>
              </div>
              <PhotoUploader
                photos={tripPhotosList}
                onAdd={handleTripPhotoUpload}
                onRemove={handleTripPhotoRemove}
                uploading={tripPhotosUploading}
                label="Ajouter des photos du véhicule (ext. + int.)"
              />
              <div style={{ display:"flex", justifyContent:"flex-end", gap:8, marginTop:20, paddingTop:16, borderTop:"0.5px solid #2a2d38" }}>
                <button style={s.primaryBtn} onClick={closeModal} className="prim-btn">
                  <CheckIcon /> Terminer
                </button>
              </div>
            </>
          )}
        </Modal>
      )}
    </div>
  );
};

export default TransporterDashboard;

/* ═══════════════════════════════════════════
   STYLES
═══════════════════════════════════════════ */
const s = {
  layout:          { display:"flex", background:"#0f1117", minHeight:"100vh", fontFamily:"'Plus Jakarta Sans',sans-serif", overflow:"hidden" },
  sidebarInner:    { display:"flex", flexDirection:"column", height:"100%", padding:"0 0 20px" },
  sidebarLogoWrap: { display:"flex", alignItems:"center", gap:8, padding:"20px 18px 16px", borderBottom:"0.5px solid #2a2d38" },
  sidebarLogo:     { fontSize:17, fontWeight:700, letterSpacing:-0.5, color:"#e8e9ed" },
  adminPill:       { fontSize:8, fontWeight:700, background:"rgba(74,222,128,0.15)", color:"#4ade80", padding:"2px 6px", borderRadius:20, textTransform:"uppercase", letterSpacing:0.8 },
  userCard:        { display:"flex", alignItems:"center", gap:10, padding:"12px 14px", margin:"8px 10px", background:"rgba(255,255,255,0.02)", borderRadius:10, border:"0.5px solid #2a2d38", minWidth:0 },
  nav:             { display:"flex", flexDirection:"column", gap:2, padding:"8px 0", flex:1 },
  navItem:         { display:"flex", alignItems:"center", gap:10, padding:"9px 16px", fontSize:13, color:"#8b8fa8", background:"none", border:"none", cursor:"pointer", fontFamily:"inherit", width:"100%", textAlign:"left", position:"relative", transition:"color 0.15s,background 0.15s" },
  navItemActive:   { color:"#e8e9ed", background:"rgba(255,255,255,0.04)" },
  navIcon:         { width:15, height:15, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 },
  navActiveBar:    { position:"absolute", left:0, top:0, bottom:0, width:2, background:"#4ade80", borderRadius:"0 2px 2px 0" },
  miniStats:       { display:"flex", justifyContent:"space-around", padding:"12px 14px", margin:"0 10px 12px", background:"rgba(255,255,255,0.02)", borderRadius:10, border:"0.5px solid #2a2d38", gap:4 },
  logoutBtn:       { display:"flex", alignItems:"center", gap:8, padding:"10px 14px", fontSize:13, color:"#8b8fa8", background:"none", border:"none", cursor:"pointer", fontFamily:"inherit", width:"100%", borderRadius:8, transition:"color 0.15s" },
  mobileTopbar:    { display:"none", alignItems:"center", justifyContent:"space-between", padding:"0 20px", height:56, background:"#16181f", borderBottom:"0.5px solid #2a2d38", position:"sticky", top:0, zIndex:100, flexShrink:0 },
  overlay:         { position:"fixed", inset:0, background:"rgba(0,0,0,0.65)", zIndex:199 },
  main:            { flex:1, overflowX:"hidden", minWidth:0, maxWidth:"100%" },
  pageHeader:      { display:"flex", alignItems:"flex-start", justifyContent:"space-between", marginBottom:24, flexWrap:"wrap", gap:12 },
  pageTitle:       { fontSize:20, fontWeight:700, color:"#e8e9ed", letterSpacing:-0.4, margin:0 },
  pageSub:         { fontSize:12, color:"#8b8fa8", marginTop:3 },
  statCard:        { background:"#16181f", border:"0.5px solid #2a2d38", borderRadius:12, padding:"16px 18px" },
  statIcon:        { width:32, height:32, borderRadius:8, display:"flex", alignItems:"center", justifyContent:"center", marginBottom:12 },
  statValue:       { fontSize:18, fontWeight:700, color:"#e8e9ed", letterSpacing:-0.5, marginBottom:2 },
  statLabel:       { fontSize:12, color:"#8b8fa8" },
  card:            { background:"#16181f", border:"0.5px solid #2a2d38", borderRadius:12, padding:"18px 20px", marginBottom:18 },
  cardTitle:       { fontSize:14, fontWeight:600, color:"#e8e9ed", margin:0, letterSpacing:-0.2 },
  tripCard:        { background:"#1a1c25", border:"0.5px solid #2a2d38", borderRadius:10, padding:"14px 16px" },
  cityTag:         { fontSize:11, background:"#1e2029", padding:"3px 8px", borderRadius:6, color:"#c8cad8", flexShrink:0 },
  emptyState:      { textAlign:"center", padding:"48px 16px", color:"#8b8fa8" },
  table:           { width:"100%", borderCollapse:"collapse", fontSize:13, minWidth:480 },
  th:              { textAlign:"left", padding:"8px 12px", color:"#8b8fa8", fontSize:11, fontWeight:500, textTransform:"uppercase", letterSpacing:"0.5px", borderBottom:"0.5px solid #2a2d38", background:"#13151b", whiteSpace:"nowrap" },
  td:              { padding:"11px 12px", borderBottom:"0.5px solid #1e2029", color:"#c8cad8", verticalAlign:"middle" },
  primaryBtn:      { display:"inline-flex", alignItems:"center", gap:7, padding:"10px 18px", background:"#4ade80", color:"#0f1117", border:"none", borderRadius:9, fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit", whiteSpace:"nowrap" },
  ghostBtn:        { display:"inline-flex", alignItems:"center", gap:7, padding:"9px 16px", background:"none", border:"0.5px solid #2a2d38", borderRadius:9, fontSize:13, color:"#8b8fa8", cursor:"pointer", fontFamily:"inherit" },
};

const rv = {
  overviewCard:    { background:"linear-gradient(145deg,#16181f,#1a1d27)", border:"0.5px solid #2a2d38", borderRadius:14, padding:"20px 22px", marginBottom:20 },
  overviewHeader:  { display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:22, paddingBottom:18, borderBottom:"0.5px solid #2a2d38", flexWrap:"wrap", gap:10 },
  overviewIconWrap:{ width:36, height:36, borderRadius:9, background:"rgba(251,191,36,0.1)", color:"#fbbf24", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 },
  overviewLabel:   { fontSize:14, fontWeight:600, color:"#e8e9ed", letterSpacing:-0.2 },
  overviewSub:     { fontSize:11, color:"#8b8fa8", marginTop:2 },
  quickRequestBtn: { marginTop:10, display:"inline-flex", alignItems:"center", gap:5, padding:"5px 12px", background:"rgba(251,191,36,0.12)", color:"#fbbf24", border:"0.5px solid rgba(251,191,36,0.25)", borderRadius:7, fontSize:11.5, fontWeight:600, cursor:"pointer", fontFamily:"inherit" },
  progressSection: { marginBottom:16 },
  progressLabel:   { fontSize:11.5, color:"#8b8fa8" },
  progressTrack:   { height:6, background:"#1e2029", borderRadius:3, overflow:"hidden" },
  progressFill:    { height:"100%", background:"linear-gradient(90deg,#4ade80,#22c55e)", borderRadius:3, transition:"width 0.6s ease" },
  infoNote:        { display:"flex", alignItems:"flex-start", gap:7, fontSize:11.5, color:"#4a4d5a", lineHeight:1.6, paddingTop:14, borderTop:"0.5px solid #1e2029" },
};

const globalCSS = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&family=DM+Mono:wght@400;500&display=swap');
  @keyframes spin  { to { transform: rotate(360deg); } }
  @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.3} }
  * { box-sizing: border-box; }

  .tp-sidebar {
    width: 230px;
    background: #16181f;
    border-right: 0.5px solid #2a2d38;
    flex-shrink: 0;
    position: sticky;
    top: 0;
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
  }
  .tp-topbar { display: none !important; }
  .tp-main { padding: 28px; }
  .nav-item-btn:hover { color: #e8e9ed !important; background: rgba(255,255,255,0.03) !important; }
  .logout-btn:hover   { color: #f87171 !important; }
  .prim-btn:hover:not(:disabled) { filter: brightness(1.08); }
  .stat-card:hover  { border-color: #3a3d4a !important; }
  .trip-card:hover  { border-color: #3a3d4a !important; }
  .brow:hover td    { background: #1a1c25 !important; }
  select option     { background: #1e2029; }
  input[type="date"]::-webkit-calendar-picker-indicator,
  input[type="datetime-local"]::-webkit-calendar-picker-indicator,
  input[type="time"]::-webkit-calendar-picker-indicator { filter: invert(0.6); cursor: pointer; }

  .stats-grid   { display: grid; grid-template-columns: repeat(5, 1fr); gap: 14px; }
  .cards-grid   { display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; }
  .coop-grid    { display: grid; grid-template-columns: 1fr 340px; gap: 18px; }
  .form-grid-2  { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 0; }
  .rv-numbers-row { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 12px; margin-bottom: 22px; }
  .rv-num-block { padding: 0; border-bottom: none !important; margin-bottom: 0 !important; }
  .rv-mini-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 16px; }

  .modal-overlay { align-items: center !important; padding: 16px !important; }
  .modal-sheet {
    background: #16181f;
    border: 0.5px solid #2a2d38;
    border-radius: 16px;
    width: 100%;
    max-width: 480px;
    max-height: 92vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .modal-wide { max-width: 640px; }
  .modal-drag-handle { display: none; }
  .modal-body { overflow-y: auto; padding: 20px; flex: 1; }

  .mobile-only  { display: none; }
  .desktop-only { display: block; }
  .bottom-nav { display: none; }

  @media (max-width: 1100px) {
    .stats-grid { grid-template-columns: repeat(3, 1fr) !important; }
    .cards-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .tp-main    { padding: 20px; }
  }

  @media (max-width: 900px) {
    .tp-sidebar { display: none !important; width: 0 !important; }
    .tp-topbar  { display: flex !important; }
    .tp-main {
      width: 100% !important;
      max-width: 100vw !important;
      overflow-x: hidden !important;
      padding: 16px 14px 90px !important;
    }
    .stats-grid     { grid-template-columns: repeat(2, 1fr) !important; gap: 10px !important; }
    .cards-grid     { grid-template-columns: 1fr !important; gap: 10px !important; }
    .coop-grid      { grid-template-columns: 1fr !important; }
    .rv-numbers-row { grid-template-columns: 1fr 1fr !important; gap: 10px !important; }
    .rv-mini-grid   { grid-template-columns: 1fr 1fr !important; gap: 10px !important; }

    .bottom-nav {
      display: flex !important;
      position: fixed;
      bottom: 0; left: 0; right: 0;
      background: #16181f;
      border-top: 0.5px solid #2a2d38;
      z-index: 150;
      padding: 0;
      padding-bottom: env(safe-area-inset-bottom, 0px);
    }
    .bottom-nav-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 10px 2px 8px;
      background: none;
      border: none;
      cursor: pointer;
      font-family: inherit;
      color: #8b8fa8;
      gap: 3px;
      min-width: 0;
      transition: color 0.15s;
    }
    .bottom-nav-item.active { color: #4ade80; }
    .bottom-nav-icon { display: flex; flex-shrink: 0; }
    .bottom-nav-label {
      font-size: 9px;
      font-weight: 600;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
    }
    .tp-sidebar.sidebar-open {
      display: flex !important;
      position: fixed;
      left: 0; top: 0;
      height: 100% !important;
      width: 260px !important;
      z-index: 200;
      animation: slideIn 0.22s ease;
    }
    .mobile-only  { display: block !important; }
    .desktop-only { display: none !important; }
    .modal-overlay { align-items: flex-end !important; padding: 0 !important; }
    .modal-sheet {
      border-radius: 20px 20px 0 0 !important;
      max-width: 100% !important;
      width: 100% !important;
      max-height: 90vh !important;
      border-bottom: none !important;
    }
    .modal-drag-handle {
      display: block;
      width: 36px; height: 4px;
      background: #3a3d4a;
      border-radius: 2px;
      margin: 12px auto 4px;
      flex-shrink: 0;
    }
    .modal-body { padding: 16px; }
  }

  @media (max-width: 640px) {
    .tp-main { padding: 12px 12px 90px !important; }
    .stats-grid     { grid-template-columns: repeat(2, 1fr) !important; gap: 8px !important; }
    .rv-numbers-row { grid-template-columns: 1fr !important; }
    .form-grid-2    { grid-template-columns: 1fr !important; }
  }

  @media (max-width: 380px) {
    .tp-main { padding: 10px 10px 88px !important; }
    .bottom-nav-label { display: none; }
    .bottom-nav-item  { padding: 14px 4px; }
    .rv-mini-grid { grid-template-columns: 1fr !important; }
  }

  @keyframes slideIn {
    from { transform: translateX(-100%); }
    to   { transform: translateX(0); }
  }
`;